module.exports = function(app) {
    app.directive('healthyPrograms', function () {
        return {
            restrict: 'A',
            templateUrl: 'landing.appTemplate.html/chmhom/directives/landing/healthyPrograms',
            controller: ['$scope', 'sessionData', 'aemContent', 'finder-logic2', 'services', 'brand', 'modal', 'wellnessUtility', 'vendorSSOUtility', 'coremetrics', 'ebillUserExists', '$q', 'UMSParse',
            function ($scope, sessionData, aemContent, finderLogic, services, brand, modal, wellnessUtility, vendorSSOUtility, coremetrics, ebillUserExists, $q, umsParse) {








                // dojo polyfills
                var lang = {hitch: function(s, f) { return f.bind(s); }}
                var dojoArray = {forEach: function(a, f) { return a.forEach(f); }, indexOf: function(a, s) { return a.indexOf(s); }}
                var djArray = dojoArray;
                // "bootstrap/utilities/Modal",
                // "bootstrap/services/services",
                // "dojo/io-query",
                // "bootstrap/utilities/Article",
                // "app/articles/FormForPostRequest"
                var btsGlobal = {config: {brand: brand.current}};

                // end dojo polyfills

                var membInCoreProgramGroup; var wellnessProfileItemDisplay;
                var hasBlueExtraBasic;
                var VBBs = null;
                var coverageIsCancelled = false;
                var is18;
                var theProductList = null;
                var wellnessProfileOptout = false;
                var portalSelectedNonMedicalPlan = '';
                var hasRewardsValue = false;
                /*ND Wellness*/
                var nd_wellnessProgramsIndicator= "false";
                var nd_wellnessProgramsOptInOutIndicator = "false";
                // the next item can have values of: juvenilleAndAdultHasntPaid, adultReadyToPayButHasnt
                //                                   adultWithNoBillingAccountId,  preEffective


                var preEffMemberType = 'none';
                // this is here, above return declare(), cause it has to be in scope inside a dojo array forEach in this.setPreEffsValues()
                var popupPreEffectuatedModal =  function(clickedItem) {
                    var usersFirstTimeOnThisPageThisSession = (sessionStorage.getItem('thisPageOpenedThisSession') != 'true');
                    var aGreyedOutItemWasClicked = (typeof clickedItem != 'undefined');
                    sessionStorage.setItem('thisPageOpenedThisSession', true);
                    if ((preEffMemberType != 'none') && ((aGreyedOutItemWasClicked) || (usersFirstTimeOnThisPageThisSession))) {
                        // we run this block only if it is the first time the page has been opened this session
                        // or if the user is clicking a link typeof sessionStorage.getItem('thisPageOpenedThisSession') != 'undefined'
                        sessionStorage.setItem('thisPageOpenedThisSession', true);
                        var that = this;
                        var ts = btsGlobal.article['landing/healthy-programs'].model.tsContent;
                        var funcs = btsGlobal.article['landing/healthy-programs'].model.funcs;
                        var modelParent = btsGlobal.article['landing/healthy-programs'].model;
                        var modalTitle, modalContent, modalButtonOneText, modalButtonTwoText, buttonTwoDisplayStyle,
                            buttonTwoFunction;
                        var cancelButtonClass = 'text-l'

                        switch (preEffMemberType) {
                            case 'juvenilleAndAdultHasntPaid':
                                if (that.cmNonPayerModal != true) {
                                    coremetrics.pageviewTag('MEMBER:MEMBER HOME:NON PAYER MODAL', 'MEMBER:MEMBER HOME');
                                    that.cmNonPayerModal = true;
                                }
                                modalTitle = ts.MBR_MBRHOME_MODALTITLE_DEPENDENT_LTDACCESS;
                                modalContent = ts.MBR_MBRHOME_MODAL_DEPENDENT_LTDACCESS;
                                modalButtonOneText = 'OK';
                                modalButtonTwoText = '';
                                buttonTwoDisplayStyle = 'none';
                                cancelButtonClass = 'juvenilleCancelButtonClass'
                                break;
                            case 'adultReadyToPayButHasnt':
                                if (that.cmPayPremiumModal != true) {
                                    coremetrics.pageviewTag('MEMBER:MEMBER HOME:MAKE PAYMENT MODAL', 'MEMBER:MEMBER HOME');
                                    that.cmPayPremiumModal = true;
                                }
                                // Your bill account #: It looks like we have not received your first payment. Until we do you will have limited access to
                                // sections and features of this site. Your first payment is due [month, DD, YYYY]. If your payment is not received by the due date, your coverage will be cancelled. Keep in mind, it may take 24-48 hours for your payment to be processed.
                                var msg = ts.MBR_MBRHOME_MODAL_PAYPREMIUM;
                                msg = msg.split('#:').join(modelParent.eBillInfo.accounttnumber + ':');
                                msg = msg.split('[month, DD, YYYY]').join(modelParent.eBillInfo.paymtduedate);

                                modalTitle = ts.MBR_MBRHOME_MODALTITLE_PAYPREMIUM;
                                modalContent = msg;
                                modalButtonOneText = 'Cancel';
                                modalButtonTwoText = 'Pay Now';
                                buttonTwoDisplayStyle = 'block';
                                buttonTwoFunction = "goToPayNow()";
                                break;
                            case 'adultWithNoBillingAccountId':
                                if (that.cmPolicyProcessingModal != true) {
                                    coremetrics.pageviewTag('MEMBER:MEMBER HOME:POLICY PROCESSING MODAL', 'MEMBER:MEMBER HOME');
                                    that.cmPolicyProcessingModal = true;
                                }
                                modalTitle = ts.MBR_MBRHOME_MODALTITLE_PROCESSING_LTDACCESS;
                                modalContent = ts.MBR_MBRHOME_MODAL_PROCESSING_LTDACCESS;
                                modalButtonOneText = 'OK';
                                // modalButtonTwoText = 'adultNoIdButTwo';
                                buttonTwoDisplayStyle = 'none';
                                cancelButtonClass = 'juvenilleCancelButtonClass'
                                break;
                            case 'preEffective':
                                modalTitle = 'LIMITED ACCESS';
                                //modalContent = 'Your plan period has not yet started. Until it does, you will have limited access to sections and features of this site.';
                                modalContent = ts.MBR_MBRHOME_MODAL_PREEFFECTIVE_LTDACCESS;
                                modalButtonOneText = 'OK';
                                buttonTwoDisplayStyle = 'none';
                                if(that.cmLimitedAccess != true) {
                                    coremetrics.pageviewTag('MEMBER:MEMBER HOME:LIMITED ACCESS MODAL','MEMBER:MEMBER HOME');
                                    that.cmLimitedAccess = true;
                                }
                                break;

                            case 'preEffectuatedAndCancelled':
                                modalTitle = ts.MBR_MBRHOME_COVCANMODALTTL;  // "COVERAGE IS CANCELLED";
                                modalContent = ts.MBR_MBRHOME_COVCANMODALTXT; // ts.MER_MBRINFO_CANCELLED;
                                modalButtonOneText = 'OK';
                                buttonTwoDisplayStyle = 'none';
                                cancelButtonClass = 'juvenilleCancelButtonClass'
                                break;
                        }
                        if (preEffMemberType == 'preEffective') {
                            new bsModal('<p>' + modalContent + '</p>' +
                                '<p class="text-r">' +
                                    //'</p><p class="text-r"><button data-click="closeModal()" class="action-btn">OK</button></p>'
                                '<button data-click="closeModal()" class="action-btn">' +
                                modalButtonOneText +
                                '</button>' +
                                '</p>' +
                                '<span class="text-r" style="float: right; display: ' + buttonTwoDisplayStyle + '">' +
                                '<button data-click="funcs.' + buttonTwoFunction + '"  class="action-btn" />' +
                                modalButtonTwoText +
                                '</button>' +
                                '</span>'
                                ,
                                {
                                    heading: modalTitle,
                                    funcs: funcs
                                }
                            );
                        }
                        else {
                            new bsModal('<p class="payNowModal">' + modalContent + '</p>' +

                                '<span class="'+ cancelButtonClass +'">' +
                                '<button data-click="closeModal()" class="action-btn">' +
                                modalButtonOneText +
                                '</button>' +
                                '</span>' +


                                '<span class="text-r" style="float: right; display: ' + buttonTwoDisplayStyle + '">' +
                                '<button data-click="funcs.' + buttonTwoFunction + '"  class="action-btn" />' +
                                modalButtonTwoText +
                                '</button>' +
                                '</span>'
                                ,
                                {
                                    heading: modalTitle,
                                    funcs: funcs
                                }
                            );
                        }
                    }
                }
                var toMerge = {

                    init: function() {

                        this.model.cmHPLauncher = function(localId) {
                            var m = btsGlobal.article['landing/healthy-programs'].model;
                            //var hostUrl = "https://" + window.location.host;
                            var that = this;
                            switch (localId) {
                                case 'idMemberDiscounts':
                                    if(that.cmMemberDiscountsClicked != true){
                                        coremetrics.elementTag('Member discounts','MEMBER:MEMBER HOME');
                                        that.cmMemberDiscountsClicked = true;
                                    }
                                    break;
                                case 'idVBB':
                                    if(that.cmValueBasedClicked != true){
                                        coremetrics.elementTag('Value Based BenefitsP','MEMBER:MEMBER HOME');
                                        that.cmValueBasedClicked = true;
                                    }
                                    break;
                                case 'idWellnessChallenges':
                                    if(that.cmWellnessChallengesClicked != true){
                                        // Site promotion tag
                                        coremetrics.createManualLinkClickTag(m.arrPrograms[2].target,null,null);
                                        //coremetrics.elementTag('WELLNESS CHALLENGES','MEMBER:MEMBER HOME');
                                        that.cmWellnessChallengesClicked = true;
                                    }
                                    break;
                                case 'idRewards':
                                    if(that.cmRewardsProgramClicked != true){
                                        // Site promotion tag
                                        coremetrics.createManualLinkClickTag(m.arrPrograms[3].target,null,null);
                                        //coremetrics.elementTag('Rewards Program','MEMBER:MEMBER HOME');
                                        that.cmRewardsProgramClicked = true;
                                    }
                                    break;
                                case 'idWellnessProfile':
                                    if(that.cmWellnessProfileClicked != true){
                                        // Site Promotion tag
                                        //coremetrics.createManualLinkClickTag(m.arrPrograms[4].target,null,null);
                                        //coremetrics.elementTag('Wellness Profile1','MEMBER:MEMBER HOME');
                                        that.cmWellnessProfileClicked = true;
                                    }
                                    break;
                                case 'idPassportRewards'://Added for CR00473169-Adding highmark passport link
                                    if(that.cmPassportRewardsClicked != true){
                                        coremetrics.elementTag('Passport Rewards','MEMBER:MEMBER HOME');
                                    }
                                    break;
                                case 'idDPP':
                                    if(that.cmDPP != true){
                                        coremetrics.elementTag('LANDING DPP LINK' ,'MEMBER:MEMBER HOME');
                                        that.cmDPP = true;
                                    }
                                    break;

                            }
                        };
                        window.theModel = this.model;
                    },
                    doStuffForDevelopmentOnly: function() {
                        // I want to show all items in Tools and Programs
                        dojoArray.forEach(this.model.arrPrograms, function(item, idx, arr) {
                            item.showThis = true;
                        });
                        btsGlobal.article['landing/the-tools'].model.showPayPlanPremium = true;
                        btsGlobal.article['landing/the-tools'].model.showSavingsAdvisor = true;
                        btsGlobal.article['landing/the-tools'].model.showPrescriptionServices = true;
                        btsGlobal.article['landing/the-tools'].model.$apply()
                    },
                    setPreEffsValues: function() {
                        var isHcr;
                        var effectiveDate;
                        var isPreEffective;
                        var isHcrPreEffectuated = false;
                        var millisServerDate = Date.parse(this.model.serverDate);
                        var products = this.model.portalSelectedPlan.productList;

                        // NOTE: we don't have to iterate the products because they will all have the same value for hcrProduct
                        if (products && products[0]) {
                            isHcr = Boolean(products[0].hcrProduct);
                            var millisPreEffectuatedDate = (Boolean(products[0].effectuatedDate)) ? Date.parse(products[0].effectuatedDate) : 1;
                            // with no effectuated date they are pre effectuated ... if other criteria are met
                            isHcrPreEffectuated = ((millisServerDate < millisPreEffectuatedDate) || (millisPreEffectuatedDate == 1)) ? true : false;
                            // we cannot use product coverageBeginDate, we need to use the members coverageEffectiveDate
                            effectiveDate = products[0].memberList[0].coverageEffectiveDate;
                            //effectiveDate = this.model.currentMember.coverageEffectiveDate // products[0].coverageBeginDate;
                        }
                        this.model.isHcrPreEffectuated = isHcr && isHcrPreEffectuated;

                        var serverDate = parseInt(Date.parse(this.model.serverDate)); //     1415139429000
                        var millisIn18Years = serverDate - 567648000000;

                        var dobMillis = 1;
                        if (this.model.currentMember) {
                            var dobMillis = Date.parse(this.model.currentMember.dob);   // -502916400000   1954
                        }

                        is18 = (serverDate - dobMillis > millisIn18Years) ? true : false; // (dobMillis < millisIn18Years) ? true : false ;

                        // grey out the correct items and make the click pop a modal and set member type for popup details
                        if(this.model.isHcrPreEffectuated) {

                            //if cancelled coverage returned from UMS and the member is preEffectuated;
                            //Then show the cancelled coverage modal in place of preEffectuated Modals
                            if(coverageIsCancelled) {
                                preEffMemberType = 'preEffectuatedAndCancelled';
                            } else {
                                // eBillAccountExists will be undefined here. We set it after the eBill service returns
                                // and we only call that service if we have to AND this setPreEffsValues method we are in here
                                // has to run before in order for us to know if we have to call that service.
                                if (this.model.eBillAccountExists) {
                                    preEffMemberType = 'adultReadyToPayButHasnt';
                                } else {
                                    preEffMemberType = 'adultWithNoBillingAccountId';
                                }
                                if (!is18) {
                                    preEffMemberType = 'juvenilleAndAdultHasntPaid';
                                }
                                if (this.model.currentMember && this.model.currentMember.relationship &&
                                    this.model.currentMember.relationship != 'Subscriber') {
                                    // we use this member type (juvenille) for Non Subscribers. They get the same popup treatment
                                    preEffMemberType = 'juvenilleAndAdultHasntPaid';
                                }
                            }

                            // grey out items -------------------------------------------------------------------
                            var arrItems = ['idWellnessProfile', 'idRewards', 'idVBB','idVBSignUp'];
                            dojoArray.forEach(this.model.arrPrograms, function(item, idx, arr) {
                                var i = dojoArray.indexOf(arrItems, item.localId);
                                if (i > -1) {
                                    item.target = 'javascript: return false';
                                    item.appearDisabled = true;
                                    item.useFunctionOnClick = true;
                                    item.clickHandler = function(localId) {
                                        btsGlobal.article['landing/healthy-programs'].model.cmHPLauncher(localId);
                                        popupPreEffectuatedModal(this);
                                    }
                                }
                            });
                            // var toolsModel = btsGlobal.article['landing/the-tools'].model;
                            // toolsModel.appearDisabled = true;
                            // toolsModel.useFunctionOnClick = true;   // prescriptionServicesClickHandler()
                            // toolsModel.prescriptionServicesClickHandler = function() {
                            //     // var that = this;
                            //     // if(that.cmPrescriptionServicesClicked != true){
                            //     //     coremetrics.elementTag('PRESCRIPTION SERVICES','MEMBER:MEMBER HOME');
                            //     //     that.cmPrescriptionServicesClicked = true;
                            //     // }
                            //     popupPreEffectuatedModal(this);
                            // }
                            // btsGlobal.article['landing/the-tools'].model.$apply();
                        }

                        isPreEffective = effectiveDate && (Date.parse(effectiveDate) > millisServerDate);
                        this.model.isPreEffective = isPreEffective;

                        if(isPreEffective && !this.model.isHcrPreEffectuated){
                            // preEffMemberType = 'preEffective';
                            // var toolsModel = btsGlobal.article['landing/the-tools'].model;
                            // toolsModel.appearDisabled = true;
                            // toolsModel.useFunctionOnClick = true;   // prescriptionServicesClickHandler()
                            // toolsModel.prescriptionServicesClickHandler = function() {
                            //     // var that = this;
                            //     // if(that.cmPrescriptionServicesClicked != true){
                            //     //     coremetrics.elementTag('PRESCRIPTION SERVICES','MEMBER:MEMBER HOME');
                            //     //     that.cmPrescriptionServicesClicked = true;
                            //     // }
                            //     popupPreEffectuatedModal(this);
                            // }
                            // btsGlobal.article['landing/the-tools'].model.$apply()
                        }
                    },
                    isBlueExtraBasic: function() {
                        var itIs = false;
                        if (this.model.portalSelectedPlan.productList) {
                            var theProductList = this.model.portalSelectedPlan.productList;
                            for (var i = 0; i < theProductList.length; i++) {
                                var theValue = theProductList[i].isBlueExtraBasic;
                                itIs = (( theValue == true) || (theValue == 'true')) ? true : itIs;
                            }
                        }
                        return itIs;
                    },
                    getportalSelectedNonMedicalPlan: function() {
                        var portalSelectedPlans = '';
                        if (this.model.portalSelectedPlan.productList) {
                            var theProductList = this.model.portalSelectedPlan.productList;
                            for (var i = 0; i < theProductList.length; i++) {
                                var theValue = theProductList[i];
                                portalSelectedPlans = portalSelectedPlans +',' + theValue.benefitPlanType ;
                            }
                        }
                        return portalSelectedPlans;
                    },
                    hasThisPlanType: function(theName) {
                        var hasIt = false;
                        theProductList = (theProductList == null) ? this.getCurrentProducts() : theProductList;
                        for (var i = 0; i < theProductList.length; i++) {
                            hasIt = (theProductList[i].benefitPlanName == theName) ? true : hasIt;
                        }
                        return hasIt;
                    },
                    coverageIsCancelled: function() {
                        var currentMember = this.model.currentMember;
                        var currentPlan = this.model.portalSelectedPlan;
                        var foundMember = false;

                        coverageIsCancelled = true;

                        if (this.model.portalSelectedPlan) {
                            for (var x = 0; x < 3; x++) {
                                switch(x) {
                                    case 0:
                                        ums.setFilterState('current');
                                        break;
                                    case 1:
                                        ums.setFilterState('past');
                                        break;
                                    case 2:
                                        ums.setFilterState('future');
                                        break;
                                }
                                var list = ums.ASMemberInfoFeed();
                                for (var z = 0; z < list.clientList.length; z++) {
                                    var client = list.clientList[z];
                                    for (var r = 0; r < client.members.length; r++) {
                                        var member = client.members[r];
                                        // if ((member.ciid == currentMember.ciid) && (member.ecId == currentMember.ecId) && (member.uniqueName == currentMember.uniqueName)) {
                                        if ((member.uniqueName == currentMember.uniqueName)) {
                                            for (var w = 0; w < member.groups.length; w++) {
                                                var group = member.groups[w];
                                                if ((group.groupNumber == currentPlan.groupNumber) && (group.clientNumber == currentPlan.clientNumber)) {
                                                    foundMember = foundMember || member;
                                                }
                                            }
                                        }
                                    }
                                }
                            }

                            if (foundMember && foundMember.cards) {
                                for (var xx = 0; xx < foundMember.cards.length; xx++) {
                                    if (foundMember.cards[xx].groupNumber === currentPlan.groupNumber) {
                                        if (foundMember.cards[xx].cancelled != "true" && foundMember.cards[xx].cancelled != true) {
                                            coverageIsCancelled = false;
                                            break;
                                        }
                                    }
                                }
                            }
                        }
                    },
                    coreShowProgramGroup: function() {
                        // we run this at preRender and populate article-global var membInCoreProgramGroup
                        if (typeof membInCoreProgramGroup == 'undefined') {
                            var isHHIC = (dojoArray.indexOf(btsGlobal.config.brand.brandVisibility, 'hhic') > -1) ? true : false;  // [0] = "hhic"
                            // Show for WPA, DE, CRE, WV ---------------------------------
                            var theRegion = btsGlobal.config.brand.domain;
                            var theseRegions = (theRegion == 'highmarkbcbs.com' || theRegion == 'highmarkbcbsde.com' ||
                            theRegion == 'highmarkblueshield.com' || theRegion == 'highmarkbcbswv.com' ) ? true : false;

                            // IBC National Alliance and Minnesota National Alliance are handled here
                            var isNationalAllianceMember = ((btsGlobal.config.brand.sharedBrandCode == 'ibc') ||
                            (btsGlobal.config.brand.sharedBrandCode == 'mn')) ? true : false;

                            var brandState = btsGlobal.config.brand.sharedBrandCode;
                            var arrayStateCodes = ['hmbcbs', 'hbcbs', 'highmarkbcbs', 'hbs', 'pbs', 'hmbs', 'hmbcbswv', 'ms', 'highmarkbcbswv', 'mbh:wv', 'hhic', 'az', 'fl', 'mbh:fl', 'exc', 'lou', 'neb', 'regbcbs', 'regbs', 'wi', 'mn', 'idh', 'la'];
                            var isMemberDiscountsRegion = (dojoArray.indexOf(arrayStateCodes, brandState) > -1) ? true : false;

                            membInCoreProgramGroup = Boolean(isHHIC || theseRegions || isMemberDiscountsRegion || isNationalAllianceMember);

                        }
                    },
                    rewardsItem: function(display_or_target_or_text) {
                        // ToDo for Phil S: I want to refactor this so the function is not hit as frequently.
                        // ToDo             I plan to do this after WellTok is finalized so I can tell if I have broken it or not
                        if (!membInCoreProgramGroup) { this.coreShowProgramGroup() }

                        var coreCriteria = membInCoreProgramGroup;
                        var hasRewardsPlan = false; //this.hasThisPlanType('Service - WebMD Rewards');
                        hasBlueExtraBasic = (typeof hasBlueExtraBasic == 'undefined') ? this.isBlueExtraBasic() : hasBlueExtraBasic;
                        var strGroups = this.model.tsContent.MBR_GLOBAL_WELLTOK_GROUPS;
                        var arrayWTGroups = strGroups && strGroups.split(';') || [];
                        var gn = this.model.portalSelectedPlan.groupNumber;   // '1706400';
                        var isWelltokGroup = (dojoArray.indexOf(arrayWTGroups, gn) > -1) ? true : false;
                        this.model.isWelltokGroup = isWelltokGroup;
                        var showRewardsOnly = (btsGlobal.config.brand.sharedBrandCode.toLowerCase()=='mincr');
                        var thisResponse;
                        this.model.isND = (btsGlobal.config.brand.sharedBrandCode.toLowerCase()=='ndbcbs');
                        this.model.isWY = (btsGlobal.config.brand.sharedBrandCode.toLowerCase()=='wybcbs');
                        switch (display_or_target_or_text) {
                            case 'display':

                                // Calling the qualifier service should be the only way to determine if a member has WebMD Rewards link display or not due to Hidden Rewards and Relationship filtering.
                                this.model.memberQualifiers.then(lang.hitch(this, function(response) {
                                    hasRewardsValue =(response.data.payload && response.data.payload.qualifierInfo.webMDRewardsIndicator) ?
                                        response.data.payload.qualifierInfo.webMDRewardsIndicator : false;
                                    hasRewardsValue = Boolean(hasRewardsValue == 'true') ? true : false;
                                }));

                                hasRewardsPlan = hasRewardsValue;

                                thisResponse = (( (coreCriteria || showRewardsOnly) && hasRewardsPlan) || (isWelltokGroup) && (!hasBlueExtraBasic));
                                break;
                            case 'target':
                                if (!isWelltokGroup) {
                                    return (this.model.tsContent.MBR_MBRHOME_PROGRAMS_REWARDS_HREF) ? this.model.tsContent.MBR_MBRHOME_PROGRAMS_REWARDS_HREF : 'NoTeamSiteInfo';
                                } else {
                                    return (this.model.tsContent.MBR_MBRHOME_PROGRAMS_WELLTOK_HREF) ? this.model.tsContent.MBR_MBRHOME_PROGRAMS_WELLTOK_HREF : 'NoTeamSiteInfo';
                                }
                                break;
                            case 'function':
                                if (isWelltokGroup) {
                                    return true;
                                }
                                return false;
                                break;
                            case 'handler':
                                if (isWelltokGroup) {
                                    return lang.hitch(this, function() {
                                        var that = this;
                                        if(that.cmRewardsProgramClicked != true){
                                            // Site promotion tag
                                            // coremetrics.createManualLinkClickTag(btsGlobal.article['landing/healthy-programs'].model.arrPrograms[3].target,null,null);
                                            //coremetrics.elementTag('Welltok Rewards Program','MEMBER:MEMBER HOME');
                                            that.cmRewardsProgramClicked = true;
                                        }

                                        var postData = {
                                            "ecid": this.model.ums.currentMember().ecId,
                                            "umi": this.model.ums.baseInformation().umi,
                                            "ciid": this.model.ums.currentMember().ciid,
                                            "clientNumber": this.model.portalSelectedPlan.clientNumber,
                                            "groupNumber": this.model.portalSelectedPlan.groupNumber
                                        };

                                        services.sso.Welltok.getData(postData).then(lang.hitch(this, function(response) {
                                            var URLparms = ioQuery.queryToObject(response.data.payload.URLparms);
                                            URLparms["source"] = location.href;
                                            URLparms =  ioQuery.objectToQuery(URLparms);
                                            var z = jQuery('<form style="display: none;" id="form-login-main" name="ssoLogin" method="post" action="'+response.data.payload.redirectionURL+'"><input name="URLparms" value="'+URLparms+'"><input name="cookieData" value="'+response.data.payload.cookieData+'"><input name="userName" value="'+response.data.payload.userName+'"><input name="destinationURL" value="'+response.data.payload.destinationURL+'"><input class="action-login-main" type="submit"></form>');
                                            jQuery('body').append(z);
                                            jQuery(".action-login-main", z).click();

                                            this.model.welltok = response.data.payload;
                                            // this.model.$apply();
                                        }));
                                    });
                                }else{
                                    return lang.hitch(this, function() {
                                        btsGlobal.article['landing/healthy-programs'].model.funcs.dorewardWebMdSso();
                                    });
                                }
                                break;
                            case 'text':
                                var theText = 'REWARDS PROGRAM';
                                thisResponse = theText;
                            default:
                                'undefined';
                        }
                        return thisResponse;
                    },
                    wellnessProfileItem: function() {
                        // member is in required region
                        var brandState = btsGlobal.config.brand.sharedBrandCode;
                        // arrayStateCodes is used to determine which brands are able to see wellness profile on home page
                        var arrayStateCodes = [];
                        var isInRegion = Boolean(dojoArray.indexOf(arrayStateCodes, brandState) > -1);
                        var isAlbertMember = brandState && this.model.currentMember.clientNumber == "255721";

                        var consumerMemberInfo = this.model.tsContent.SHARECARE_SOFTLAUNCH_GROUPS;
                       // var consumerMemberList = $(consumerMemberInfo).text().split(',');
                        var isConsumerMember =false;
                        //var isConsumerMember = (dojoArray.indexOf(consumerMemberList, this.model.portalSelectedPlan.groupNumber) > -1) ? true : false;
                        if(consumerMemberInfo.indexOf(this.model.portalSelectedPlan.groupNumber)>-1) {//wellnessVendorIndicator indicator changes For HMHS
                            isConsumerMember =true;
                        } else if((consumerMemberInfo === "service") && sessionData.memberInfo!==null &&
                            (sessionData.memberInfo.brand ==="HMBCBS" || sessionData.memberInfo.brand ==="DE" ||
                            sessionData.memberInfo.brand ==="PBS" || sessionData.memberInfo.brand ==="MS")
                            && sessionData.memberInfo.clientList!==null
                            && sessionData.memberInfo.clientList.length >=1 &&
                            sessionData.memberInfo.clientList[0].groupList!==null &&
                            sessionData.memberInfo.clientList[0].groupList.length >=1){
                            for(var i=0; i<sessionData.memberInfo.clientList[0].groupList.length;i++) {
                                if (this.model.portalSelectedPlan.groupNumber === sessionData.memberInfo.clientList[0].groupList[i].groupNumber) {
                                    if (sessionData.memberInfo.clientList[0].groupList[i].wellnessVendorIndicator!==null &&
                                        sessionData.memberInfo.clientList[0].groupList[i].wellnessVendorIndicator === "ShareCare") {
                                        isConsumerMember = true;//wellnessVendorIndicator indicator changes
                                    }
                                    isConsumerMember = true;//WEB MD HIDING for HMHS Group Changes
                                }
                            }
                        }
                        var consumerMemberInfo_MN = this.model.tsContent.SHARECARE_SOFTLAUNCH_GROUPS_MN;//MN Group Changes
                        var consumerMemberList_MN = $(consumerMemberInfo_MN).text().split(',');//MN Group Changes
                        //var isConsumerMember_MN = (dojoArray.indexOf(consumerMemberList_MN, this.model.portalSelectedPlan.groupNumber) > -1) ? true : false;
                        var isConsumerMember_MN = false;

                        if(consumerMemberInfo_MN.indexOf(this.model.portalSelectedPlan.groupNumber)>-1) {
                            isConsumerMember_MN =true;
                        } else if((consumerMemberInfo_MN === "service") && sessionData.memberInfo!==null && sessionData.memberInfo.brand ==="MINCR"
                            && sessionData.memberInfo.clientList!==null
                            && sessionData.memberInfo.clientList.length >=1 &&
                            sessionData.memberInfo.clientList[0].groupList!==null &&
                            sessionData.memberInfo.clientList[0].groupList.length >=1){
                            for(var i=0; i<sessionData.memberInfo.clientList[0].groupList.length;i++) {
                                if (this.model.portalSelectedPlan.groupNumber === sessionData.memberInfo.clientList[0].groupList[i].groupNumber) {
                                    if (sessionData.memberInfo.clientList[0].groupList[i].wellnessVendorIndicator!==null &&
                                        sessionData.memberInfo.clientList[0].groupList[i].wellnessVendorIndicator === "ShareCare") {
                                    isConsumerMember_MN = true;//wellnessVendorIndicator indicator changes
                                }
                                    isConsumerMember_MN = true;//WEB MD HIDING for MN Group Changes
                                }
                            }
                        }
                        this.model.isConsumerMember_MN =isConsumerMember_MN;
                        if (!this.model.currentMember) {
                            wellnessProfileItemDisplay = false;
                            return;
                        }
                        if(isConsumerMember_MN)//MN Group Changes
                        {
                            wellnessProfileItemDisplay = false;
                            return;
                        }
                        if(isConsumerMember)//WEB MD HIDING for HMHS Group Changes
                        {
                            wellnessProfileItemDisplay = false;
                            return;
                        }
                        wellnessProfileItemDisplay = isInRegion && !coverageIsCancelled && !isAlbertMember && !isConsumerMember;

                        //hide the wellness profile link on landing page if indicated optout
                        wellnessProfileItemDisplay &= !wellnessProfileOptout;

                        this.model.arrPrograms[4].showThis = wellnessProfileItemDisplay;
                    },
                    valueBasedSignUpRegion: function() {
                        var arrayVbsStateCodes = ['hmbcbs', 'hbcbs', 'highmarkbcbs', 'hbs', 'pbs', 'hmbs',"hmbcbswv", "ms", "highmarkbcbswv", "mbh:wv","hmbcbsde", "highmarkbcbsde", "de","pp","hhic","az","fl", "mbh:fl","neb","inac", "ibc", 'mincr', 'la'];
                        var returnThis = Boolean(dojoArray.indexOf(arrayVbsStateCodes, btsGlobal.config.brand.sharedBrandCode) > -1);
                        return returnThis;
                    },
                    getCurrentProducts: function() {
                        var currentPlans = [];
                        var millisNow = Date.parse(this.model.serverDate);
                        if (this.model.portalSelectedPlan && this.model.portalSelectedPlan.productList && this.model.portalSelectedPlan.productList.length > 0) {
                            var the_prods = this.model.portalSelectedPlan.productList;
                        } else {
                            return currentPlans;
                        }
                        for (var i = 0; i < the_prods.length; i++) {
                            var millisBeginDate = Date.parse(the_prods[i].coverageBeginDate);
                            var millisEndDate = Date.parse(the_prods[i].coverageEndDate);
                            if ((millisBeginDate < millisNow) && (millisNow < millisEndDate)) {
                                currentPlans.push(the_prods[i])
                            }else{
                                // Fix issue with last day of availability for WebMD Challenge
                                if (the_prods[i].benefitPlanName == "Service - WebMD Challenges"){
                                    var covEndDt = new Date(millisEndDate);
                                    var todayDate = new Date(millisNow);
                                    // check date only instead of milliseconds
                                    if (todayDate.toLocaleDateString() <= covEndDt.toLocaleDateString()){
                                        currentPlans.push(the_prods[i]);
                                    }
                                }
                            };
                        }
                        return currentPlans;
                    },
                    getVBBs: function() {
                        // they gotta have a current Medical plan and a valueBasedBenefits object with a SignedUp property
                        theProductList = (theProductList == null) ? this.getCurrentProducts() : theProductList;
                        var intMedicalAndCurrPlan = null;
                        for (var i = 0; i < theProductList.length; i++) {
                            if (theProductList[i].benefitPlanType == 'Medical') {
                                intMedicalAndCurrPlan = i;
                            }
                        }
                        if (intMedicalAndCurrPlan == null) { return null; }
                        // I assume that if they have the item on the tree and the valueBasedBenefitsSignedUp property is a boolean
                        // then they are in a group offering VBB
                        if(btsGlobal.config.brand.sharedBrandCode.toLowerCase()=='mincr')
                        {
                            VBBs=null;
                        }else {
                            VBBs = (theProductList[intMedicalAndCurrPlan].valueBasedBenefits &&
                            typeof theProductList[intMedicalAndCurrPlan].valueBasedBenefits.valueBasedBenefitsSignedUp == 'boolean') ?
                                theProductList[intMedicalAndCurrPlan].valueBasedBenefits : null;
                        }
                    },
                    showVbbItem: function() {
                        if (VBBs && this.valueBasedSignUpRegion() ) {
                            return true; }
                        else {
                            return false; }
                    },


                    replaceContentPlaceholder: function(content, placeholderValue) {
                        if(content && placeholderValue){
                            return content.replace("#",placeholderValue);
                        }
                        return content;
                    },
                    callWellnessScoreService: function () {
                        var deferredWPScore = $q.defer();
                        services.rbsmbl.wellnessProfileScore().fetch().then(
                            lang.hitch(this, function(response) {
                                var wellnessProfileScoreResponse = (response.data.payload && response.data.payload.wellnessProfileScore) ?
                                    response.data.payload.wellnessProfileScore : null;

                                this.model.wellnessProfileScore = wellnessProfileScoreResponse;
                                // this.model.$apply();
                                // we gotta put the score in this and make the item show
                                this.model.arrPrograms[4].subItem.showThis = (wellnessProfileScoreResponse != null) ? true : false;
                                this.model.arrPrograms[4].subItem.the_text += wellnessProfileScoreResponse;

                                deferredWPScore.resolve();
                            }),
                            lang.hitch(this, function(error) {
                                    // TODO: It is unclear how errors are being handled in this situation.

                                    // the service can return this here "ERROR_WELLNESS_PROFILE_SCORE_NOT_RETURN  I (pds) don't think its an error but that not my call

                                    // Issue with denv to show up the whole Wellness Programs section because of the error baseMessage;
                                    try {
                                        var errorBaseMessage = error.response.data.baseMessage.returnCodeDescription;
                                    }
                                    catch (err) {
                                    }
                                    deferredWPScore.resolve();
                                }
                            )
                        );
                        return deferredWPScore.promise;
                    },
                    //Added for CR00473169-Adding highmark passport link
                    passportRewards: function() {

                        if (!membInCoreProgramGroup) { this.coreShowProgramGroup() }
                        var hasPassportRewards;
                        var coreCriteria = membInCoreProgramGroup;
                        var planList = ['SECURITYBLUE HMO','SECURITY BLUE HMO','FREEDOMBLUE PPO','FREEDOM BLUE PPO','COMMUNITY BLUE MEDICARE HMO'];

                        for (var i = 0; i < planList.length; i++) {
                            var hasPassportRewards = this.hasThisPlanType(planList[i]);
                            if(hasPassportRewards==true)
                                break;
                        }
                        //var hasPassportRewards = this.hasThisPlanType('asdasd','BLUE CARD');



                        return hasPassportRewards;
                    },
                    showCMR: function(infoData){
                        if(infoData == undefined || infoData == null)
                            {
                            return false;
                            }
                        else if(infoData.memberList[0].packages[0] == undefined || infoData.memberList[0].packages[0] == null){
                            return false;
                            }
                           else if(infoData.memberList[0].packages[0].packageCode == "CONDITION MNGT" && infoData.memberList[0].packages[0].memberEligibility && btsGlobal.config.brand.sharedBrandCode.toLowerCase()=='mincr'){
                               return true;
                           }
                           else{
                               return false;
                           }
                    },
                    showECMR: function(infoData){
                            if(infoData == undefined || infoData == null)
                            {
                                return false;
                            }
                            else if(infoData.memberList[0].packages[0] == undefined || infoData.memberList[0].packages[0] == null){
                                return false;
                            }
                            else if(infoData.memberList[0].packages[0].packageCode == "PROTOCOL COMPL" && infoData.memberList[0].packages[0].memberEligibility && btsGlobal.config.brand.sharedBrandCode.toLowerCase()=='mincr')
                            {
                                return true;
                            }
                            else{
                                return false;
                            }
                    },
                    populateModel: function(m) {

                        this.model.memberQualifiers.then(lang.hitch(this, function(response) {
                            nd_wellnessProgramsIndicator = response.data.payload.qualifierInfo.wellnessProgramsIndicator;
                            nd_wellnessProgramsOptInOutIndicator = response.data.payload.qualifierInfo.wellnessProgramsOptInOutIndicator;
                        }));

                        var tt = this.getVBBs();
                        if((btsGlobal.config.brand.sharedBrandCode=='ndbcbs')){
                            if((nd_wellnessProgramsIndicator=="true") && (nd_wellnessProgramsOptInOutIndicator == "true")){
                                m.programsTitle = m.tsContent.MBR_MBRHOME_PROGRAMS_TITLE ? m.tsContent.MBR_MBRHOME_PROGRAMS_TITLE : 'WELLNESS INFORMATION';
                                m.programsLink = "/member/wellness"
                                m.programsDescription = m.tsContent.MBR_MBRHOME_PROGRAMS_DESCRIPTION ? m.tsContent.MBR_MBRHOME_PROGRAMS_DESCRIPTION : 'These wellness programs can help you stay healthy and save money';
                            }else {
                                    m.programsTitle = m.tsContent.MBR_MBRHOME_PROGRAMS_TITLE_NDBCBS ? m.tsContent.MBR_MBRHOME_PROGRAMS_TITLE_NDBCBS : 'WELLNESS INFORMATION';
                                    m.programLink = "/member/claims/educational-materials";
                                    m.programsDescription = m.tsContent.MBR_MBRHOME_PROGRAMS_DESCRIPTION_NDBCBS ? m.tsContent.MBR_MBRHOME_PROGRAMS_DESCRIPTION_NDBCBS : 'Access common forms members use most - authorizations, claim forms and more.';
                            }

                        }else if(btsGlobal.config.brand.sharedBrandCode.toLowerCase()=='wybcbs'){
                            m.programsTitle = m.tsContent.MBR_MBRHOME_PROGRAMS_TITLE_WYBCBS ? m.tsContent.MBR_MBRHOME_PROGRAMS_TITLE_WYBCBS : 'HEALTH ASSESSMENT';
                            m.programsDescription = m.tsContent.MBR_MBRHOME_PROGRAMS_DESCRIPTION_WYBCBS ? m.tsContent.MBR_MBRHOME_PROGRAMS_DESCRIPTION_WYBCBS : 'Get a picture of your health and find tips to make choices that are good for you.';
                        }else{
                            m.programsTitle = m.tsContent.MBR_MBRHOME_PROGRAMS_TITLE ? m.tsContent.MBR_MBRHOME_PROGRAMS_TITLE : 'WELLNESS INFORMATION';
                            m.programsDescription = m.tsContent.MBR_MBRHOME_PROGRAMS_DESCRIPTION ? m.tsContent.MBR_MBRHOME_PROGRAMS_DESCRIPTION : 'These wellness programs can help you stay healthy and save money';
                        }
                        var consumerMemberInfo = this.model.tsContent.SHARECARE_SOFTLAUNCH_GROUPS;
                        var isConsumerMember =false;
                        if(consumerMemberInfo.indexOf(this.model.portalSelectedPlan.groupNumber)>-1) {//wellnessVendorIndicator indicator changes For HMHS
                            isConsumerMember =true;
                        } else if((consumerMemberInfo === "service") && sessionData.memberInfo!==null &&
                            (sessionData.memberInfo.brand ==="HMBCBS" || sessionData.memberInfo.brand ==="DE" ||
                            sessionData.memberInfo.brand ==="PBS" || sessionData.memberInfo.brand ==="MS")
                            && sessionData.memberInfo.clientList!==null
                            && sessionData.memberInfo.clientList.length >=1 &&
                            sessionData.memberInfo.clientList[0].groupList!==null &&
                            sessionData.memberInfo.clientList[0].groupList.length >=1){
                            for(var i=0; i<sessionData.memberInfo.clientList[0].groupList.length;i++) {
                                if (this.model.portalSelectedPlan.groupNumber === sessionData.memberInfo.clientList[0].groupList[i].groupNumber) {
                                    if (sessionData.memberInfo.clientList[0].groupList[i].wellnessVendorIndicator!==null &&
                                        sessionData.memberInfo.clientList[0].groupList[i].wellnessVendorIndicator === "ShareCare") {
                                        isConsumerMember = true;//wellnessVendorIndicator indicator changes
                                    }
                                    isConsumerMember = true;//wellnessVendorIndicator indicator changes
                                }
                            }
                        }
                        //var consumerMemberList = $(consumerMemberInfo).text().split(',');
                        //var isConsumerMember = (dojoArray.indexOf(consumerMemberList, this.model.portalSelectedPlan.groupNumber) > -1) ? true : false;
                        var consumerMemberInfo_MN = this.model.tsContent.SHARECARE_SOFTLAUNCH_GROUPS_MN;//MN Group Changes
                        var consumerMemberList_MN = $(consumerMemberInfo_MN).text().split(',');//MN Group Changes

                       // var isConsumerMember_MN = (dojoArray.indexOf(consumerMemberList_MN, this.model.portalSelectedPlan.groupNumber) > -1) ? true : false;
                        var isConsumerMember_MN = false;
                        if(consumerMemberInfo_MN.indexOf(this.model.portalSelectedPlan.groupNumber)>-1) {
                            isConsumerMember_MN =true;
                        }else if((consumerMemberInfo_MN === "service") && sessionData.memberInfo!==null && sessionData.memberInfo.brand ==="MINCR"
                            && sessionData.memberInfo.clientList!==null
                            && sessionData.memberInfo.clientList.length >=1 &&
                            sessionData.memberInfo.clientList[0].groupList!==null &&
                            sessionData.memberInfo.clientList[0].groupList.length >=1){
                            for(var i=0; i<sessionData.memberInfo.clientList[0].groupList.length;i++) {
                                if (this.model.portalSelectedPlan.groupNumber === sessionData.memberInfo.clientList[0].groupList[i].groupNumber) {
                                    if (sessionData.memberInfo.clientList[0].groupList[i].wellnessVendorIndicator!==null &&
                                        sessionData.memberInfo.clientList[0].groupList[i].wellnessVendorIndicator === "ShareCare") {
                                        isConsumerMember_MN = true;//wellnessVendorIndicator indicator changes
                                    }
                                }
                            }
                        }
                        if(isConsumerMember){
                            m.programsTitle = m.tsContent.MBR_MBRHOME_PROGRAMS_SHARECARE_TITLE ? m.tsContent.MBR_MBRHOME_PROGRAMS_SHARECARE_TITLE:'WELLNESS INFORMATION';
                            m.programsDescription = m.tsContent.MBR_MBRHOME_SHARECARE_PROGRAMS_DESCRIPTION ? m.tsContent.MBR_MBRHOME_SHARECARE_PROGRAMS_DESCRIPTION : 'These programs can help you stay healthy and save money.';
                        }
                        m.funcs = {};
                        m.funcs.goToPayNow = function() {
                            btsGlobal.article.Modal.model.closeModal();
                            window.location = '#!/landing/payNow'
                        };
                        //Added for CR00473169-Adding highmark passport link
                        m.funcs.displayEarnPassportRewards= function() {
                            if (this._showingDialog) {
                                return;
                            }

                            this._showingDialog = true;
                            var passportModal = JSON.parse(m.tsContent.MBR_WELLNESS_PASSPORT_REWARDS_MODAL);
                            myFunction = function() {
                                var theDomain = 'https://' + window.location.host;
                                window.open(theDomain + passportModal.linkHref);
                            };
                             new bsModal('<p>' + passportModal.description + ' <a onclick="myFunction()">' + passportModal.linkText + '</a>.</p><p class="margin-top text-r"><button class="action-btn" data-click="closeModal()">OK</button></p>', {
                                heading: passportModal.title,
                                onClose: lang.hitch(this, function() {
                                    this._showingDialog = false;
                                })
                            });
                        },
                            m.funcs.dorewardWebMdSso = function() {
                                var articleModel = btsGlobal.article['landing/healthy-programs'].model;
                                var cmSP = "WebMD-_-Rewards Program WebMD-_-" + m.arrPrograms[3].the_text.toUpperCase();

                                var postData = {
                                    "clientNumber": articleModel.portalSelectedPlan.clientNumber,
                                    "groupNumber": articleModel.portalSelectedPlan.groupNumber,
                                    "vendorName": articleModel.memberInfoFeed.brand,
                                    "targetType": "WELLNESS_REWARDS",
                                    "category":"WELLNESS",
                                    "returnPage": "Member_Home",
                                    "returnUrl": '/mbr/#!/landing'
                                };

                                services.sso.VendorSSO.getData(articleModel.username, articleModel.memberInfoFeed.brand, postData).then(function (ssoResponse) {
                                    coremetricsSP = cmSP;
                                    targetLocation =  "_self";
                                    btsGlobal.article['landing/healthy-programs'].model.funcs.handleSSOResponse(ssoResponse, coremetricsSP, targetLocation);


                                }, function (error) {
                                    //TODO: Do something more useful with the error of the SSO promise.
                                });



                            },
                            m.funcs.doWebMdSso = function() {
                                // this is hit when the user clicks the WELLNESS PROFILE item
                                // Coremetrics variables

                                var that = this;
                                var cmSP = "WebMD-_-Wellness Profile-_-" + btsGlobal.article['landing/healthy-programs'].model.arrPrograms[4].the_text.toUpperCase();
                                var articleModel = btsGlobal.article['landing/healthy-programs'].model;
                                var csd = '';
                                var mySessionUrl = 'https://' + window.location.host;  // "https://denv7.highmarkbcbs.com"
                                mySessionUrl = mySessionUrl.split('denv').join('tenv');
                                var cvgBeginDate ='';

                                var activeWellnessPlan = btsGlobal.page.landing.model.getThisCurrentlyActiveProduct('Medical', articleModel);
                                if( activeWellnessPlan == null) // fix for wellness profile not loading if productlist does not have Medical plan
                                    activeWellnessPlan = btsGlobal.page.landing.model.getThisCurrentlyActiveNonMedicalProduct(portalSelectedNonMedicalPlan, articleModel);

                                if ((typeof activeWellnessPlan == 'undefined') || activeWellnessPlan == null ||
                                    (typeof activeWellnessPlan.coverageBeginDate == 'undefined') || activeWellnessPlan.coverageBeginDate == null)
                                {
                                    if (articleModel.portalSelectedPlan.productList)
                                    {
                                        var theProductList = articleModel.portalSelectedPlan.productList;

                                        for (var i = 0; i < theProductList.length; i++)
                                        {
                                            if (theProductList[i].benefitPlanType == 'Medical')
                                            {
                                                cvgBeginDate = theProductList[i].coverageBeginDate;
                                                break;

                                            }
                                            else if (theProductList[i].benefitPlanType == 'Wellness Programs')
                                            {

                                                cvgBeginDate = theProductList[i].coverageBeginDate;
                                                break;
                                            }
                                        }

                                    }
                                }
                                else {
                                    cvgBeginDate = activeWellnessPlan.coverageBeginDate;
                                }

                                var postData = {
                                    "clientNumber": articleModel.portalSelectedPlan.clientNumber, // "099918",
                                    "groupNumber": articleModel.portalSelectedPlan.groupNumber, // "08149300",
                                    "vendorName": articleModel.memberInfoFeed.brand, // "HMBCS",
                                    "targetType": "WELLNESS_PROFILE",
                                    "category":"WELLNESS",
                                    "returnPage": "Member_Home",
                                    "returnUrl": '/mbr/#!/landing'
                                };

                                services.sso.VendorSSO.getData(articleModel.username, articleModel.memberInfoFeed.brand, postData).then(function (ssoResponse) {
                                    coremetricsSP = cmSP;

                                    targetLocation =  "_self";
                                    btsGlobal.article['landing/healthy-programs'].model.funcs.handleSSOResponse(ssoResponse, coremetricsSP, targetLocation);

                                }, function (error) {
                                    //TODO: Do we need to handle the error to this promise as well as the one above?
                                });


                                articleModel.loadingWellnessProfile = true;

                            };

                            m.funcs.handleSSOResponse=  function(ssoResponse, coremetricsSP, targetLocation) {
                            if (ssoResponse && ssoResponse.data && ssoResponse.data.payload) {

                                if (document.getElementById('invisibleSsoForm')) {
                                    document.getElementById('invisibleSsoForm').innerHTML = "";
                                }

                                var urlAppend = (ssoResponse.data.payload.ssoUrl.indexOf("?") > -1) ? "&" : "?";
                                var sitePromo = (coremetricsSP.indexOf("?") === 0) ? coremetricsSP.substring(1) : coremetricsSP;
                                sitePromo = (sitePromo.length > 0 && sitePromo.indexOf("cm_sp=") < 0) ? "cm_sp=" + sitePromo : sitePromo ;
                                var theUrl = (sitePromo.length > 0) ? ssoResponse.data.payload.ssoUrl + urlAppend + sitePromo : ssoResponse.data.payload.ssoUrl;

                                if (ssoResponse.data.payload.ssoRequestType === 'FORM-POST') {
                                    var objModel = {
                                        "formName": "invisibleSsoForm",
                                        "formId": "invisibleSsoFormId",
                                        "formMethod": "POST",
                                        "formAction": theUrl,
                                        "formTarget": targetLocation || "invisibleSsoSvc",
                                        "formVariables": []
                                    };

                                    djArray.forEach(ssoResponse.data.payload.ssoFormParams, function (curParam, idx) {
                                        objModel.formVariables.push({
                                            "varName": curParam.name,
                                            "varId": curParam.name,
                                            "varValue": curParam.value
                                        });
                                    });

                                    var newArt = new bsArticle({
                                        controller: FormForPostRequest,
                                        name: 'FormForPostRequest',
                                        target: 'invisibleSsoForm',
                                        position: 'last',
                                        model: objModel
                                    });

                                    newArt.ready(function () {
                                        if (document.getElementById('invisibleSsoFormId')) {
                                            document.getElementById('invisibleSsoFormId').submit();
                                        }
                                    });
                                }
                                else if (ssoResponse.data.payload.ssoRequestType === 'REDIRECT') {
                                    location.href = theUrl;
                                    articleModel.loadingWellnessProfile = false;
                                }
                            }
                        }
                        var itemWellnessProfileScore = m.arrPrograms[4].subItem;
                        itemWellnessProfileScore.showThis = (m.wellnessProfileScore != null) ? true : false;
                        var rewardsLink = m.arrPrograms[3];
                        if(hasRewardsValue == true)
                        {
                            var consumerMemberInfo = this.model.tsContent.SHARECARE_SOFTLAUNCH_GROUPS;
                            var isConsumerMember =false;
                            if(consumerMemberInfo.indexOf(this.model.portalSelectedPlan.groupNumber)>-1) {//wellnessVendorIndicator indicator changes For HMHS
                                isConsumerMember =true;
                            } else if((consumerMemberInfo === "service") && sessionData.memberInfo!==null &&
                                (sessionData.memberInfo.brand ==="HMBCBS" || sessionData.memberInfo.brand ==="DE" ||
                                sessionData.memberInfo.brand ==="PBS" || sessionData.memberInfo.brand ==="MS")
                                && sessionData.memberInfo.clientList!==null
                                && sessionData.memberInfo.clientList.length >=1 &&
                                sessionData.memberInfo.clientList[0].groupList!==null &&
                                sessionData.memberInfo.clientList[0].groupList.length >=1){
                                for(var i=0; i<sessionData.memberInfo.clientList[0].groupList.length;i++) {
                                    if (this.model.portalSelectedPlan.groupNumber === sessionData.memberInfo.clientList[0].groupList[i].groupNumber) {
                                        if (sessionData.memberInfo.clientList[0].groupList[i].wellnessVendorIndicator!==null &&
                                            sessionData.memberInfo.clientList[0].groupList[i].wellnessVendorIndicator === "ShareCare") {
                                            isConsumerMember = true;//wellnessVendorIndicator indicator changes
                                        }
                                        isConsumerMember = true;//wellnessVendorIndicator indicator changes
                                    }
                                }
                            }
                            //var consumerMemberList = $(consumerMemberInfo).text().split(',');
                            //var isConsumerMember = (dojoArray.indexOf(consumerMemberList, this.model.portalSelectedPlan.groupNumber) > -1) ? true : false;
                            rewardsLink.showThis = hasRewardsValue && !isConsumerMember;
                        }
                        // m.$apply();
                    },
                    makeArrPrograms: function(dppData, infoData) {

                        var m = this.model;
                        // Coremetrics Site Promotion parameter query tag.
                        var cmSP;
                        m.arrPrograms = [
                            {   // 'MEMBER DISCOUNTS',
                                localId: 'idMemberDiscounts',
                                the_text: m.tsContent.MBR_MBRHOME_PROGRAMS_DISCOUNTS ? m.tsContent.MBR_MBRHOME_PROGRAMS_DISCOUNTS : 'Member Discounts',
                                showThis: membInCoreProgramGroup,
                                // showThis: true,
                                imgUrl: '/mbr/app/imgs/landing/tools-and-programs/memberDiscounts.png',
                                //target: (m.tsContent.MBR_MBRHOME_PROGRAMS_DISCOUNTS_HREF) ? m.tsContent.MBR_MBRHOME_PROGRAMS_DISCOUNTS_HREF : 'NoTeamSiteContent'
                                target: '/member/coverage/medical-benefits?scroll=memberDiscounts'
                            },
                            {   // VALUE-BASED BENEFITS
                                localId: 'idVBB',
                                the_text: m.tsContent.MBR_MBRHOME_PROGRAMS_VALBASED ? m.tsContent.MBR_MBRHOME_PROGRAMS_VALBASED : 'Value-Based Benefits',
                                showThis: this.showVbbItem(),
                                imgUrl: '/mbr/app/imgs/landing/tools-and-programs/valueBased.png',
                                useFunctionOnClick: true,
                                clickHandler: function() {
                                    alert("Please call customer service number on the back of your ID card for questions regarding Value Based Benefits or to sign up for conditions");
                                }
                                //target: (m.tsContent.MBR_MBRHOME_PROGRAMS_VALBASED_LINK) ? m.tsContent.MBR_MBRHOME_PROGRAMS_VALBASED_LINK : 'NoTeamSiteContent'
                            }, 
                            {   // 'WELLNESS CHALLENGES'
                                localId: 'idWellnessChallenges',
                                the_text: m.tsContent.MBR_MBRHOME_PROGRAMS_WELLCHALLENGES ? m.tsContent.MBR_MBRHOME_PROGRAMS_WELLCHALLENGES : 'Wellness Challenges',
                                showThis: this.hasThisPlanType('Service - WebMD Challenges'),
                                // showThis: true,
                                imgUrl: '/mbr/app/imgs/landing/tools-and-programs/webMDChallenges.png',
                                target: (m.tsContent.MBR_MBRHOME_PROGRAMS_WELLCHALLENGES_HREF) ? m.tsContent.MBR_MBRHOME_PROGRAMS_WELLCHALLENGES_HREF : 'NoTeamSiteInfo'
                                // target: '/chmptl/chm/jsp/webMDSingleSignOn.do?startId=713&hmLinkcodeValue=MBR_POST_LAND&hmLinkName=Member Home'},
                            },
                            {   // REWARDS
                                localId: 'idRewards',
                                the_text: m.tsContent.MBR_MBRHOME_PROGRAMS_REWARDS ? m.tsContent.MBR_MBRHOME_PROGRAMS_REWARDS : 'Rewards Program',
                                showThis:this.rewardsItem('display'),
                                // showThis: true,
                                imgUrl: '/mbr/app/imgs/landing/tools-and-programs/webMDRewards.png',
                                target: '',//this.rewardsItem('target'),
                                useFunctionOnClick: true,//this.rewardsItem('function'),
                               clickHandler: this.rewardsItem('handler')
                            },

                            {   // WELLNESS PROFILE
                                localId: 'idWellnessProfile',
                                the_text: (m.tsContent.MBR_MBRHOME_PROGRAMS_WELLPROFILE) ? m.tsContent.MBR_MBRHOME_PROGRAMS_WELLPROFILE : 'Wellness Profile',
                                subItem: {
                                    the_text: m.tsContent.MBR_MBRHOME_PROGRAMS_WELLPROFILE_SCORE ? this.replaceContentPlaceholder(m.tsContent.MBR_MBRHOME_PROGRAMS_WELLPROFILE_SCORE,this.model.wellnessProfileScore ) : 'Wellness Profile score:',
                                    localId: 'idWellnessProfileScore',
                                    showThis: (this.model.wellnessProfileScore!=null) ? true : false
                                },
                                showThis: wellnessProfileItemDisplay,
                                hasWelcomeTooltip: true,
                                // target: (m.tsContent.MBR_MBRHOME_PROGRAMS_WELLPROFILE_HREF) ? m.tsContent.MBR_MBRHOME_PROGRAMS_WELLPROFILE_HREF : 'NoTeamSiteContent',
                                // '/chmptl/chm/jsp/webMDSingleSignOn.do?startId=1004&hmLinkcodeValue=MBR_POST_LAND&hmLinkName=Member Home';
                                imgUrl: '/mbr/app/imgs/landing/tools-and-programs/wellenssProfile.png',
                                useFunctionOnClick: true,
                                clickHandler: function() {
                                    // couldn't reach the methods in next level up so had to use btsGlobal
                                    btsGlobal.article['landing/healthy-programs'].model.funcs.doWebMdSso();
                                }
                            },

                            {   // 'PASSPORT REWARDS',//Added for CR00473169-Adding highmark passport link
                                localId: 'idPassportRewards',
                                //the_text: m.tsContent.MBR_MBRHOME_PROGRAMS_DISCOUNTS ? m.tsContent.MBR_MBRHOME_PROGRAMS_DISCOUNTS : '{{MBR_MBRHOME_PROGRAMS_DISCOUNTS}}',
                                the_text: 'Highmark Passport Rewards',
                                showThis: this.passportRewards(),
                                useFunctionOnClick: true,
                                clickHandler: function() {
                                    btsGlobal.article['landing/healthy-programs'].model.funcs.displayEarnPassportRewards();
                                }
                            },
                            {  
                                localId: 'idDPP',
                                the_text: 'DIABETES PREVENTION',
                                showThis: ((dppData == "MA") || (dppData =="C")),
                                imgUrl: '/mbr/app/imgs/landing/tools-and-programs/dppIcon.png',
                                linkTarget:'_self',
                                target: '/member/wellness/dppDetails'//(m.tsContent.MBR_MBRHOME_PROGRAMS_VALBASED_LINK) ? m.tsContent.MBR_MBRHOME_PROGRAMS_VALBASED_LINK : 'NoTeamSiteContent'

                            },
                            {   // CARE MANAGEMENT REWARD
                                localId: 'idCMR',
                                the_text: 'CARE MANAGEMENT REWARD',
                                showThis: this.showCMR(infoData),
                                imgUrl: '/mbr/app/imgs/landing/tools-and-programs/cmr.png',
                                linkTarget:'_self',
                                target: '/member/wellness/ccs'

                            },
                            {
                                localId: 'idECMR',
                                the_text: 'ENHANCED CARE MANAGEMENT REWARD',
                                showThis: this.showECMR(infoData),
                                imgUrl: '/mbr/app/imgs/landing/tools-and-programs/cmr.png',
                                linkTarget:'_self',
                                target: '/member/wellness/ccs'

                            }
                        ]


                        var consumerMemberInfo = this.model.tsContent.SHARECARE_SOFTLAUNCH_GROUPS;
                        var isConsumerMember =false;
                        if(consumerMemberInfo.indexOf(this.model.portalSelectedPlan.groupNumber)>-1) {//wellnessVendorIndicator indicator changes For HMHS
                            isConsumerMember =true;
                        } else if((consumerMemberInfo === "service") && sessionData.memberInfo!==null &&
                            (sessionData.memberInfo.brand ==="HMBCBS" || sessionData.memberInfo.brand ==="DE" ||
                            sessionData.memberInfo.brand ==="PBS" || sessionData.memberInfo.brand ==="MS")
                            && sessionData.memberInfo.clientList!==null
                            && sessionData.memberInfo.clientList.length >=1 &&
                            sessionData.memberInfo.clientList[0].groupList!==null &&
                            sessionData.memberInfo.clientList[0].groupList.length >=1){
                            for(var i=0; i<sessionData.memberInfo.clientList[0].groupList.length;i++) {
                                if (this.model.portalSelectedPlan.groupNumber === sessionData.memberInfo.clientList[0].groupList[i].groupNumber) {
                                    if (sessionData.memberInfo.clientList[0].groupList[i].wellnessVendorIndicator!==null &&
                                        sessionData.memberInfo.clientList[0].groupList[i].wellnessVendorIndicator === "ShareCare") {
                                        isConsumerMember = true;//wellnessVendorIndicator indicator changes
                                    }
                                    isConsumerMember = true;//wellnessVendorIndicator indicator changes
                                }
                            }
                        }
                        //var consumerMemberList = $(consumerMemberInfo).text().split(',');
                        //var isConsumerMember = (dojoArray.indexOf(consumerMemberList, this.model.portalSelectedPlan.groupNumber) > -1) ? true : false;
                            if(isConsumerMember){
                                m.arrPrograms[6].the_text = 'Diabetes Prevention Program';
                            }

                        var tsResponse=this.model.clientGroupProductQualifiedTSContent;

                        var additionalLinks=[{
                            'linkObj': tsResponse.MBR_MBRHOME_WELLNESS_PROGRAMS_LINK1?JSON.parse(tsResponse.MBR_MBRHOME_WELLNESS_PROGRAMS_LINK1):tsResponse.MBR_MBRHOME_WELLNESS_PROGRAMS_LINK1,
                            'imgUrl': tsResponse.MBR_MBRHOME_WELLNESS_PROGRAMS_LINK1_IMG
                        },{
                            'linkObj': tsResponse.MBR_MBRHOME_WELLNESS_PROGRAMS_LINK2?JSON.parse(tsResponse.MBR_MBRHOME_WELLNESS_PROGRAMS_LINK2):tsResponse.MBR_MBRHOME_WELLNESS_PROGRAMS_LINK2,
                            'imgUrl': tsResponse.MBR_MBRHOME_WELLNESS_PROGRAMS_LINK2_IMG
                        }, {
                            'linkObj': tsResponse.MBR_MBRHOME_WELLNESS_PROGRAMS_LINK3?JSON.parse(tsResponse.MBR_MBRHOME_WELLNESS_PROGRAMS_LINK3):tsResponse.MBR_MBRHOME_WELLNESS_PROGRAMS_LINK3,
                            'imgUrl': tsResponse.MBR_MBRHOME_WELLNESS_PROGRAMS_LINK3_IMG
                        }
                        ];

                        // filters the additional responsive links
                        for(i=0; i<additionalLinks.length; i++){
                            if(additionalLinks[i].linkObj && additionalLinks[i].linkObj.target && additionalLinks[i].linkObj.target.length>0) {
                                additionalLinks[i].showThis=true;
                                additionalLinks[i].the_text=additionalLinks[i].linkObj.defaultText;
                                additionalLinks[i].target=additionalLinks[i].linkObj.href;
                                additionalLinks[i].linkTarget=additionalLinks[i].linkObj.target;
                                m.arrPrograms[m.arrPrograms.length + i] = additionalLinks[i];
                            }
                        }

                        // Add Site Promotion query parameter to target URLs
                        // Wellness Challenges
                        cmSP = "&cm_sp=WebMD-_-Wellness Challenges-_-" + m.arrPrograms[2].the_text.toUpperCase();
                        cmSP = cmSP.replace(/ /g,'%20');
                        m.arrPrograms[2].target = m.arrPrograms[2].target + cmSP;
                        // Wellness Rewards
                        // Check for WebMD or Welltok
                        if (m.arrPrograms[3].target) {
                            if (m.arrPrograms[3].target.indexOf('webMD') > -1) {
                                cmSP = "&cm_sp=WebMD-_-Rewards Program WebMD-_-";
                            } else {
                                cmSP = "?cm_sp=Welltok-_-Rewards Program Welltok-_-";
                            }
                            cmSP = cmSP +  m.arrPrograms[3].the_text.toUpperCase();
                            cmSP = cmSP.replace(/ /g,'%20');
                            m.arrPrograms[3].target = m.arrPrograms[3].target + cmSP;
                        }
                        ////MN Group Changes
                        var consumerMemberinfo_MN = this.model.tsContent.SHARECARE_SOFTLAUNCH_GROUPS_MN;
                        var consumerMemberList_MN = $(consumerMemberinfo_MN).text().split(',');
                        var consumerMemberInfo_MN = this.model.tsContent.SHARECARE_SOFTLAUNCH_GROUPS_MN;//MN Group Changes
                        //var isConsumerMember_MN = (dojoArray.indexOf(consumerMemberList_MN, this.model.portalSelectedPlan.groupNumber) > -1) ? true : false;
                        var isConsumerMember_MN = false;
                        if(consumerMemberInfo_MN.indexOf(this.model.portalSelectedPlan.groupNumber)>-1) {
                            isConsumerMember_MN =true;
                        } else if((consumerMemberInfo_MN === "service") && sessionData.memberInfo!==null && sessionData.memberInfo.brand ==="MINCR"
                            && sessionData.memberInfo.clientList!==null
                        && sessionData.memberInfo.clientList.length >=1 &&
                            sessionData.memberInfo.clientList[0].groupList!==null &&
                            sessionData.memberInfo.clientList[0].groupList.length >=1){
                            for(var i=0; i<sessionData.memberInfo.clientList[0].groupList.length;i++) {
                                if (this.model.portalSelectedPlan.groupNumber === sessionData.memberInfo.clientList[0].groupList[i].groupNumber) {
                                    if (sessionData.memberInfo.clientList[0].groupList[i].wellnessVendorIndicator!==null &&
                                        sessionData.memberInfo.clientList[0].groupList[i].wellnessVendorIndicator === "ShareCare") {
                                        isConsumerMember_MN = true;//wellnessVendorIndicator indicator changes
                                    }
                                }
                            }
                        }
                        if(isConsumerMember_MN && (!(window.location.host.indexOf('denv') > -1))&&!(window.location.host.indexOf('tenv') > -1)) {
                            m.arrPrograms.push({    //MN Group Changes
                                localId: 'idShareCare',
                                the_text: 'ShareCare',
                                showThis: isConsumerMember_MN,
                                imgUrl: '/mbr/app/imgs/landing/tools-and-programs/sharecare_landing.png',
                                linkTarget: '_blank',
                               // target: 'https://bluecrossmn.sharecare.com/',
                                target: this.model.tsContent.MBR_WELLNESS_SHARECARE_LINK,
                                sharecareflagdisplay: 'true'

                            })
                            m.arrPrograms.push({    //MN Group Changes
                                localId: 'idallwellnessprograms',
                                the_text: 'All Wellness Programs',
                                showThis: isConsumerMember_MN,
                                linkTarget: '',
                                target: '/member/wellness',
                                allwellnessflag: 'true'
                            })
                        }//MN Group Changes
                        if(isConsumerMember_MN && ((window.location.host.indexOf('denv') > -1))||(window.location.host.indexOf('tenv') > -1)) {
                            m.arrPrograms.push({    //MN Group Changes
                                localId: 'idShareCare',
                                the_text: 'ShareCare',
                                showThis: isConsumerMember_MN,
                                imgUrl: '/mbr/app/imgs/landing/tools-and-programs/sharecare_landing.png',
                                linkTarget: '_blank',
                                //target: 'https://bluecrossmn.stage.sharecare.com',
                                target: this.model.tsContent.MBR_WELLNESS_SHARECARE_LINK_TEST,
                                sharecareflagdisplay: 'true'

                            })
                            m.arrPrograms.push({    //MN Group Changes
                                localId: 'idallwellnessprograms',
                                the_text: 'All Wellness Programs',
                                showThis: isConsumerMember_MN,
                                linkTarget: '',
                                target: '/member/wellness',
                                allwellnessflag: 'true'
                            })
                        }//MN Group Changes

                        /*ND WELLNESS*/
                        if(btsGlobal.config.brand.sharedBrandCode.toLowerCase()==='ndbcbs'){
                            if((nd_wellnessProgramsIndicator=="true") && (nd_wellnessProgramsOptInOutIndicator == "true")) {
                                m.arrPrograms.push({
                                    localId: 'idHealthyBlue',
                                    the_text: 'HEALTHYBLUE HOME',
                                    showThis: true,
                                    imgUrl: '/mbr/app/imgs/landing/tools-and-programs/wellenssProfile.png',
                                    linkTarget: '_blank',
                                    target: '/emssvc/x-services/secure/sso/outbound/auto/v1/vendor/WEBMDND?StartID=87'

                                })
                                m.arrPrograms.push({
                                    localId: 'idWellness',
                                    the_text: 'WELLNESS PROFILE',
                                    showThis: true,
                                    imgUrl: '/mbr/app/imgs/landing/tools-and-programs/dppIcon.png',
                                    linkTarget: '_blank',
                                    target: '/emssvc/x-services/secure/sso/outbound/auto/v1/vendor/WEBMDND?StartID=3563'

                                })
                            }
                            else {
                                m.arrPrograms.push({   // HIPAA
                                    localId: 'idHIPAA',
                                    the_text: 'HIPAA AUTHORIZATION',
                                    showThis: true,
                                    //imgUrl: ' ',
                                    linkTarget: '_blank',
                                    target: '/member/HIPAA'

                                })
                                m.arrPrograms.push( {   // PRENATAL
                                    localId: 'idPRENATAL',
                                    the_text: 'PRENATAL PLUS PROGRAM',
                                    showThis: true,
                                    //imgUrl: ' ',
                                    linkTarget:'',
                                    target: '/member/prenatal'

                                })
                            }
                        }

                        if(btsGlobal.config.brand.sharedBrandCode.toLowerCase()==='wybcbs') {
                            m.arrPrograms.push({   // GET STARTED
                                localId: 'idGETSTARTED',
                                the_text: 'GET STARTED',
                                showThis: true,
                               // imgUrl: ' ',
                                linkTarget: '_blank',
                                target: this.model.tsContent.MBR_WELLNESS_SHARECARE_LINK
                            })
                        }
                        // this.model.$apply();
                    },

                    isWellnessProfileOptout: function(theMemberInfo)
                    {
                        wellnessProfileOptout = false;
                        optOutList = theMemberInfo.clientList[0].groupList[0].optOutList;
                        if(optOutList)
                        {
                            for(i = 0; i < optOutList.length; i++)
                            {
                                if(optOutList[i].description === 'Wellness Profile')
                                {
                                    wellnessProfileOptout = true;
                                    break;
                                }
                            }
                        }
                    },
                    getTeamsiteContent: function() {
                        return aemContent.getAEMJsonContent().then(function(data) {
                            return {
                                //PCP POR
                                'MBR_MGRLANDING_ALERTS_POR': aemContent.getContentValue(data['MBR_MGRLANDING_ALERTS_POR']),
                                'MBR_MBRLANDING_ALERTS_PCP': aemContent.getContentValue(data['MBR_MBRLANDING_ALERTS_PCP']),
                                'LANDING_PCP_POR_DUMMY_CODES': aemContent.getContentValue(data['LANDING_PCP_POR_DUMMY_CODES']),
                                'MBR_MBRHOME_BANNER_PRE_EFFECTUATED_TITLE': aemContent.getContentValue(data['MBR_MBRHOME_BANNER_PRE_EFFECTUATED_TITLE']),
                                'MBR_MBRHOME_BANNER_PRE_EFFECTUATED_DESCRIPTION': aemContent.getContentValue(data['MBR_MBRHOME_BANNER_PRE_EFFECTUATED_DESCRIPTION']),
                                'MBR_MBRHOME_BANNER_PRE_EFFECTUATED_RIBBON_ITEMS': aemContent.getContentValue(data['MBR_MBRHOME_BANNER_PRE_EFFECTUATED_RIBBON_ITEMS']),
                                'MBR_MBRHOME_BANNER_FORMS_LIBRARY_TITLE': aemContent.getContentValue(data['MBR_MBRHOME_BANNER_FORMS_LIBRARY_TITLE']),
                                'MBR_MBRHOME_BANNER_FORMS_LIBRARY_TITLE_ND': aemContent.getContentValue(data['MBR_MBRHOME_BANNER_FORMS_LIBRARY_TITLE_ND']),
                                'MBR_MBRHOME_BANNER_FORMS_LIBRARY_DESCRIPTION': aemContent.getContentValue(data['MBR_MBRHOME_BANNER_FORMS_LIBRARY_DESCRIPTION']),
                                'MBR_MBRHOME_BANNER_FORMS_LIBRARY_DESCRIPTION_ND': aemContent.getContentValue(data['MBR_MBRHOME_BANNER_FORMS_LIBRARY_DESCRIPTION_ND']),
                                'MBR_MBRHOME_BANNER_BENEFIT_SEARCH_TITLE': aemContent.getContentValue(data['MBR_MBRHOME_BANNER_BENEFIT_SEARCH_TITLE']),
                                'MBR_MBRHOME_ALERTS_SPENDING_OUTAGE': aemContent.getContentValue(data['MBR_MBRHOME_ALERTS_SPENDING_OUTAGE']),
                                'MBR_MBRHOME_ALERTS_SPENDING_OUTAGE_2': aemContent.getContentValue(data['MBR_MBRHOME_ALERTS_SPENDING_OUTAGE_2']),
                                'MBR_MBRHOME_ALERTS_SPENDING_OUTAGE_AFTER_EFFECTIVE': aemContent.getContentValue(data['MBR_MBRHOME_ALERTS_SPENDING_OUTAGE_AFTER_EFFECTIVE']),
                                'MBR_MBRHOME_ALERTS_SPENDING_OUTAGE_AFTER_EFFECTIVE_2': aemContent.getContentValue(data['MBR_MBRHOME_ALERTS_SPENDING_OUTAGE_AFTER_EFFECTIVE_2']),
                                'MBR_MBRHOME_ALERTS_SERVICE_DOWN': aemContent.getContentValue(data['MBR_MBRHOME_ALERTS_SERVICE_DOWN']),
                                'MBR_MBRHOME_ALERTS_SERVICE_DOWN_SABLACKOUT': aemContent.getContentValue(data['MBR_MBRHOME_ALERTS_SERVICE_DOWN_SABLACKOUT']),
                                'MBR_MBRHOME_SMART_MESSAGE': aemContent.getContentValue(data['MBR_MBRHOME_SMART_MESSAGE']),
                                'MBR_MBRHOME_BANNER_CMS_TITLE': aemContent.getContentValue(data['MBR_MBRHOME_BANNER_CMS_TITLE']),
                                'MBR_MBRHOME_BANNER_CMS_DESCRIPTION': aemContent.getContentValue(data['MBR_MBRHOME_BANNER_CMS_DESCRIPTION']),
                                'MBR_MBRHOME_BANNER_CMS_LINK_ACA': aemContent.getContentValue(data['MBR_MBRHOME_BANNER_CMS_LINK_ACA']),
                                'MBR_MBRHOME_BANNER_CMS_LINK_TAX': aemContent.getContentValue(data['MBR_MBRHOME_BANNER_CMS_LINK_TAX']),
                                'MBR_MBRHOME_HEALTHTOOLS_TITLE': aemContent.getContentValue(data['MBR_MBRHOME_HEALTHTOOLS_TITLE']),
                                'MBR_MBRHOME_HEALTHTOOLS_DESCRIPTION': aemContent.getContentValue(data['MBR_MBRHOME_HEALTHTOOLS_DESCRIPTION']),
                                'MBR_MBRHOME_HEALTHTOOLS_SMARTSHOPPER_LABEL': aemContent.getContentValue(data['MBR_MBRHOME_HEALTHTOOLS_SMARTSHOPPER_LABEL']),
                                'MBR_MBRHOME_HEALTHTOOLS_FORMS_LIBRARY': aemContent.getContentValue(data['MBR_MBRHOME_HEALTHTOOLS_FORMS_LIBRARY']),
                                'MBR_MBRHOME_HEALTHTOOLS_BENEFIT_SEARCH': aemContent.getContentValue(data['MBR_MBRHOME_HEALTHTOOLS_BENEFIT_SEARCH']),
                                'MBR_MBRHOME_HEALTHTOOLS_CASTLIGHT_LINK': aemContent.getContentValue(data['MBR_MBRHOME_HEALTHTOOLS_CASTLIGHT_LINK']),
                                'MBR_MBRHOME_HEALTHTOOLS_COMPCOST_LINK': aemContent.getContentValue(data['MBR_MBRHOME_HEALTHTOOLS_COMPCOST_LINK']),
                                'MBR_MBRHOME_HEALTHTOOLS_SAVINGSADV_LINK': aemContent.getContentValue(data['MBR_MBRHOME_HEALTHTOOLS_SAVINGSADV_LINK']),
                                'MBR_MBRHOME_HEALTHTOOLS_SAVINGSADV_LINK_MINCR': aemContent.getContentValue(data['MBR_MBRHOME_HEALTHTOOLS_SAVINGSADV_LINK_MINCR']),
                                'MBR_MBRHOME_VITALS_MODAL': aemContent.getContentValue(data['MBR_MBRHOME_VITALS_MODAL']),
                                'MBR_MBRHOME_HEALTHTOOLS_PROVIDER_LINK': aemContent.getContentValue(data['MBR_MBRHOME_HEALTHTOOLS_PROVIDER_LINK']),
                                'MBR_MBRHOME_HEALTHTOOLS_PAYPREMIUM_REGISTERED': aemContent.getContentValue(data['MBR_MBRHOME_HEALTHTOOLS_PAYPREMIUM_REGISTERED']),
                                'MBR_MBRHOME_HEALTHTOOLS_PAYPREMIUM_UNREGISTERED': aemContent.getContentValue(data['MBR_MBRHOME_HEALTHTOOLS_PAYPREMIUM_UNREGISTERED']),
                                'MBR_MBRHOME_HEALTHTOOLS_PAYPREMIUM_REGISTERED_NEW': aemContent.getContentValue(data['MBR_MBRHOME_HEALTHTOOLS_PAYPREMIUM_REGISTERED_NEW']),
                                'MBR_MBRHOME_HEALTHTOOLS_PAYPREMIUM_UNREGISTERED_NEW': aemContent.getContentValue(data['MBR_MBRHOME_HEALTHTOOLS_PAYPREMIUM_UNREGISTERED_NEW']),
                                'MBR_MBRHOME_HEALTHTOOLS_PAYPREMIUM_EBILL': aemContent.getContentValue(data['MBR_MBRHOME_HEALTHTOOLS_PAYPREMIUM_EBILL']),
                                'MBR_MBRHOME_HEALTHTOOLS_MYCHART_LINK': aemContent.getContentValue(data['MBR_MBRHOME_HEALTHTOOLS_MYCHART_LINK']),
                                'MBR_MBRHOME_HEALTHTOOLS_PROVIDER_LINK_HREF': aemContent.getContentValue(data['MBR_MBRHOME_HEALTHTOOLS_PROVIDER_LINK_HREF']),
                                'MBR_MBRHOME_HEALTHTOOLS_CASTLIGHT_LINK_HREF': aemContent.getContentValue(data['MBR_MBRHOME_HEALTHTOOLS_CASTLIGHT_LINK_HREF']),
                                'MBR_MBRHOME_HEALTHTOOLS_COMPCOST_LINK_HREF': aemContent.getContentValue(data['MBR_MBRHOME_HEALTHTOOLS_COMPCOST_LINK_HREF']),
                                'MBR_MBRHOME_HEALTHTOOLS_SAVINGSADV_LINK_HREF': aemContent.getContentValue(data['MBR_MBRHOME_HEALTHTOOLS_SAVINGSADV_LINK_HREF']),
                                'MBR_MBRHOME_HEALTHTOOLS_MYCHART_LINK_HREF': aemContent.getContentValue(data['MBR_MBRHOME_HEALTHTOOLS_MYCHART_LINK_HREF']),
                                'MBR_MBRHOME_FORMS_LIBRARY_LINK_HREF': aemContent.getContentValue(data['MBR_MBRHOME_FORMS_LIBRARY_LINK_HREF']),
                                'MBR_MBRHOME_FORMS_LIBRARY_LINK_HREF_ND': aemContent.getContentValue(data['MBR_MBRHOME_FORMS_LIBRARY_LINK_HREF_ND']),
                                'MBR_MBRHOME_BENEFIT_SEARCH_LINK_HREF': aemContent.getContentValue(data['MBR_MBRHOME_BENEFIT_SEARCH_LINK_HREF']),
                                'MBR_MBRHOME_HEALTHTOOLS_BENEFIT_SEARCH_LINK': aemContent.getContentValue(data['MBR_MBRHOME_HEALTHTOOLS_BENEFIT_SEARCH_LINK']),
                                'MBR_GLOBAL_WELLTOK_GROUPS': aemContent.getContentValue(data['MBR_GLOBAL_WELLTOK_GROUPS']),
                                'MBR_MBRHOME_PROGRAMS_TITLE': aemContent.getContentValue(data['MBR_MBRHOME_PROGRAMS_TITLE']),
                                'MBR_MBRHOME_PROGRAMS_SHARECARE_TITLE': aemContent.getContentValue(data['MBR_MBRHOME_PROGRAMS_SHARECARE_TITLE']),
                                'MBR_MBRHOME_SHARECARE_PROGRAMS_DESCRIPTION': aemContent.getContentValue(data['MBR_MBRHOME_SHARECARE_PROGRAMS_DESCRIPTION']),
                                'MBR_MBRHOME_PROGRAMS_DESCRIPTION': aemContent.getContentValue(data['MBR_MBRHOME_PROGRAMS_DESCRIPTION']),
                                'MBR_MBRHOME_PROGRAMS_TITLE_NDBCBS': aemContent.getContentValue(data['MBR_MBRHOME_PROGRAMS_TITLE_NDBCBS']),
                                'MBR_MBRHOME_PROGRAMS_DESCRIPTION_NDBCBS': aemContent.getContentValue(data['MBR_MBRHOME_PROGRAMS_DESCRIPTION_NDBCBS']),
                                'MBR_MBRHOME_PROGRAMS_TITLE_WYBCBS': aemContent.getContentValue(data['MBR_MBRHOME_PROGRAMS_TITLE_WYBCBS']),
                                'MBR_MBRHOME_PROGRAMS_DESCRIPTION_WYBCBS': aemContent.getContentValue(data['MBR_MBRHOME_PROGRAMS_DESCRIPTION_WYBCBS']),
                                'MBR_MBRHOME_PROGRAMS_DISCOUNTS': aemContent.getContentValue(data['MBR_MBRHOME_PROGRAMS_DISCOUNTS']),
                                'MBR_MBRHOME_PROGRAMS_DISCOUNTS_HREF': aemContent.getContentValue(data['MBR_MBRHOME_PROGRAMS_DISCOUNTS_HREF']),
                                'MBR_MBRHOME_PROGRAMS_WELLPROFILE': aemContent.getContentValue(data['MBR_MBRHOME_PROGRAMS_WELLPROFILE']),
                                'MBR_MBRHOME_PROGRAMS_WELLPROFILE_HREF': aemContent.getContentValue(data['MBR_MBRHOME_PROGRAMS_WELLPROFILE_HREF']),
                                'MBR_MBRHOME_PROGRAMS_WELLPROFILE_SCORE': aemContent.getContentValue(data['MBR_MBRHOME_PROGRAMS_WELLPROFILE_SCORE']),
                                'MBR_MBRHOME_PROGRAMS_REWARDS': aemContent.getContentValue(data['MBR_MBRHOME_PROGRAMS_REWARDS']),
                                'MBR_MBRHOME_PROGRAMS_REWARDS_HREF': aemContent.getContentValue(data['MBR_MBRHOME_PROGRAMS_REWARDS_HREF']),
                                'MBR_MBRHOME_PROGRAMS_WELLTOK_HREF': aemContent.getContentValue(data['MBR_MBRHOME_PROGRAMS_WELLTOK_HREF']),
                                'MBR_MBRHOME_PROGRAMS_WELLCHALLENGES': aemContent.getContentValue(data['MBR_MBRHOME_PROGRAMS_WELLCHALLENGES']),
                                'MBR_MBRHOME_PROGRAMS_WELLCHALLENGES_HREF': aemContent.getContentValue(data['MBR_MBRHOME_PROGRAMS_WELLCHALLENGES_HREF']),
                                'MBR_MBRHOME_PROGRAMS_VALBASED_SIGNUP': aemContent.getContentValue(data['MBR_MBRHOME_PROGRAMS_VALBASED_SIGNUP']),
                                'MBR_MBRHOME_PROGRAMS_VALBASED_SIGNUP_HREF': aemContent.getContentValue(data['MBR_MBRHOME_PROGRAMS_VALBASED_SIGNUP_HREF']),
                                'MBR_MBRHOME_PROGRAMS_VALBASED': aemContent.getContentValue(data['MBR_MBRHOME_PROGRAMS_VALBASED']),
                                'MBR_MBRHOME_PROGRAMS_VALBASED_LINK': aemContent.getContentValue(data['MBR_MBRHOME_PROGRAMS_VALBASED_LINK']),
                                'MBR_MBRHOME_MODALTITLE_PAYPREMIUM': aemContent.getContentValue(data['MBR_MBRHOME_MODALTITLE_PAYPREMIUM']),
                                'MBR_MBRHOME_MODAL_PAYPREMIUM': aemContent.getContentValue(data['MBR_MBRHOME_MODAL_PAYPREMIUM']),
                                'MBR_MBRHOME_MODALTITLE_PROCESSING_LTDACCESS': aemContent.getContentValue(data['MBR_MBRHOME_MODALTITLE_PROCESSING_LTDACCESS']),
                                'MBR_MBRHOME_MODAL_PROCESSING_LTDACCESS': aemContent.getContentValue(data['MBR_MBRHOME_MODAL_PROCESSING_LTDACCESS']),
                                'MBR_MBRHOME_MODALTITLE_DEPENDENT_LTDACCESS': aemContent.getContentValue(data['MBR_MBRHOME_MODALTITLE_DEPENDENT_LTDACCESS']),
                                'MBR_MBRHOME_MODAL_DEPENDENT_LTDACCESS': aemContent.getContentValue(data['MBR_MBRHOME_MODAL_DEPENDENT_LTDACCESS']),
                                'MBR_MBRHOME_MODALTITLE_WAYSTOPAY': aemContent.getContentValue(data['MBR_MBRHOME_MODALTITLE_WAYSTOPAY']),
                                'MBR_MBRHOME_MODAL _WAYSTOPAY': aemContent.getContentValue(data['MBR_MBRHOME_MODAL _WAYSTOPAY']),
                                'MBR_MBRHOME_MODAL _WAYSTOPAY_ONLINE': aemContent.getContentValue(data['MBR_MBRHOME_MODAL _WAYSTOPAY_ONLINE']),
                                'MBR_MBRHOME_MODAL _WAYSTOPAY_PHONE': aemContent.getContentValue(data['MBR_MBRHOME_MODAL _WAYSTOPAY_PHONE']),
                                'MBR_MBRHOME_MODAL _WAYSTOPAY_PRNTMAIL': aemContent.getContentValue(data['MBR_MBRHOME_MODAL _WAYSTOPAY_PRNTMAIL']),
                                'MBR_MBRHOME_MODAL_PREEFFECTIVE_LTDACCESS': aemContent.getContentValue(data['MBR_MBRHOME_MODAL_PREEFFECTIVE_LTDACCESS']),
                                'MBR_WELLNESS_PASSPORT_REWARDS_MODAL': aemContent.getContentValue(data['MBR_WELLNESS_PASSPORT_REWARDS_MODAL']),
                                'SHARECARE_SOFTLAUNCH_GROUPS': aemContent.getContentValue(data['SHARECARE_SOFTLAUNCH_GROUPS']),
                                'SHARECARE_SOFTLAUNCH_GROUPS_MN': aemContent.getContentValue(data['SHARECARE_SOFTLAUNCH_GROUPS_MN']),
                                'MBR_WELLNESS_SHARECARE_LINK': aemContent.getContentValue(data['MBR_WELLNESS_SHARECARE_LINK']),
                                'MBR_WELLNESS_SHARECARE_LINK_TEST': aemContent.getContentValue(data['MBR_WELLNESS_SHARECARE_LINK_TEST']),
                                'MBR_MBRHOME_ESPOTS_MINCR': aemContent.getContentValue(data['MBR_MBRHOME_ESPOTS_MINCR']),
                                'MBR_MBRHOME_ESPOT_IDTHEFT_SRC': aemContent.getContentValue(data['MBR_MBRHOME_ESPOT_IDTHEFT_SRC']),
                                'MBR_MBRHOME_ESPOT_IDTHEFT_TARGET': aemContent.getContentValue(data['MBR_MBRHOME_ESPOT_IDTHEFT_TARGET']),
                                'MBR_MBRHOME_ESPOT_MYCARENAVIGATOR_SRC': aemContent.getContentValue(data['MBR_MBRHOME_ESPOT_MYCARENAVIGATOR_SRC']),
                                'MBR_MBRHOME_ESPOT_MYCARENAVIGATOR_TEXT': aemContent.getContentValue(data['MBR_MBRHOME_ESPOT_MYCARENAVIGATOR_TEXT']),
                                'MBR_MBRHOME_ESPOT_MYCARENAVIGATOR_TARGET': aemContent.getContentValue(data['MBR_MBRHOME_ESPOT_MYCARENAVIGATOR_TARGET']),
                                'MER_MBRINFO_GRPPEND': aemContent.getContentValue(data['MER_MBRINFO_GRPPEND']),
                                'MER_MBRINFO_GRPREADY': aemContent.getContentValue(data['MER_MBRINFO_GRPREADY']),
                                'MER_MBRINFO_COVINACTIVE': aemContent.getContentValue(data['MER_MBRINFO_COVINACTIVE']),
                                'MER_MBRINFO_FUTURE': aemContent.getContentValue(data['MER_MBRINFO_FUTURE']),
                                'MER_MBRINFO_NOPAY': aemContent.getContentValue(data['MER_MBRINFO_NOPAY']),
                                'MER_MBRINFO_CANCELLED': aemContent.getContentValue(data['MER_MBRINFO_CANCELLED']),
                                'MBR_MBRHOME_COVCANMODALTTL': aemContent.getContentValue(data['MBR_MBRHOME_COVCANMODALTTL']),
                                'MBR_MBRHOME_COVCANMODALTXT': aemContent.getContentValue(data['MBR_MBRHOME_COVCANMODALTXT']),
                                'MER_MBRINFO_FUTURE_IBCCR': aemContent.getContentValue(data['MER_MBRINFO_FUTURE_IBCCR']),
                                'MER_MBRINFO_FUTURE_IBCAH': aemContent.getContentValue(data['MER_MBRINFO_FUTURE_IBCAH']),
                                'MBR_MBRHOME_ALERTS_HSA': aemContent.getContentValue(data['MBR_MBRHOME_ALERTS_HSA']),
                                'MBR_MBRHOME_ALERTS_HSA_LINK': aemContent.getContentValue(data['MBR_MBRHOME_ALERTS_HSA_LINK']),
                                'MBR_MBRHOME_ALERTS_HSA_LINK_HREF': aemContent.getContentValue(data['MBR_MBRHOME_ALERTS_HSA_LINK_HREF']),
                                'MBR_MBRHOME_ALERTS_CLAIMS': aemContent.getContentValue(data['MBR_MBRHOME_ALERTS_CLAIMS']),
                                'MBR_MBRHOME_ALERTS_CLAIMS_1': aemContent.getContentValue(data['MBR_MBRHOME_ALERTS_CLAIMS_1']),
                                'MBR_MBRHOME_ALERTS_CLAIMS_LINK': aemContent.getContentValue(data['MBR_MBRHOME_ALERTS_CLAIMS_LINK']),
                                'MBR_MBRHOME_ALERTS_SPENDING': aemContent.getContentValue(data['MBR_MBRHOME_ALERTS_SPENDING']),
                                'MBR_MBRHOME_ALERTS_SPENDING_1': aemContent.getContentValue(data['MBR_MBRHOME_ALERTS_SPENDING_1']),
                                'MBR_MBRHOME_ALERTS_SPENDING_LINK': aemContent.getContentValue(data['MBR_MBRHOME_ALERTS_SPENDING_LINK']),
                                'MBR_MBRHOME_ALERTS_SPENDING_LINK_HREF': aemContent.getContentValue(data['MBR_MBRHOME_ALERTS_SPENDING_LINK_HREF']),
                                'MBR_MBRHOME_ALERTS_PRIORAUTH': aemContent.getContentValue(data['MBR_MBRHOME_ALERTS_PRIORAUTH']),
                                'MBR_MBRHOME_ALERTS_PRIORAUTH_HREF': aemContent.getContentValue(data['MBR_MBRHOME_ALERTS_PRIORAUTH_HREF']),
                                'MBR_MBRHOME_ALERTS_PRIORAUTH_LINK': aemContent.getContentValue(data['MBR_MBRHOME_ALERTS_PRIORAUTH_LINK']),
                                'MBR_MBRHOME_ALERTS_EMAIL': aemContent.getContentValue(data['MBR_MBRHOME_ALERTS_EMAIL']),
                                'MBR_MBRHOME_ALERTS_EMAIL_LINK': aemContent.getContentValue(data['MBR_MBRHOME_ALERTS_EMAIL_LINK']),
                                'MBR_MBRHOME_ALERTS_EMAIL_LINK_HREF': aemContent.getContentValue(data['MBR_MBRHOME_ALERTS_EMAIL_LINK_HREF']),
                                'MBR_MBRHOME_ALERTS_PAPERLESS': aemContent.getContentValue(data['MBR_MBRHOME_ALERTS_PAPERLESS']),
                                'MBR_MBRHOME_ALERTS_PAPERLESS_1': aemContent.getContentValue(data['MBR_MBRHOME_ALERTS_PAPERLESS_1']),
                                'MBR_MBRHOME_ALERTS_PAPERLESS_LINK': aemContent.getContentValue(data['MBR_MBRHOME_ALERTS_PAPERLESS_LINK']),
                                'MBR_MBRHOME_ALERTS_PAPERLESS_LINK_HREF': aemContent.getContentValue(data['MBR_MBRHOME_ALERTS_PAPERLESS_LINK_HREF']),
                                'MBR_MBRHOME_TOPHEADER_CATEGORYTITLE': aemContent.getContentValue(data['MBR_MBRHOME_TOPHEADER_CATEGORYTITLE']),
                                'MBR_MBRHOME_RIBBON_MEMINFO': aemContent.getContentValue(data['MBR_MBRHOME_RIBBON_MEMINFO']),
                                'MBR_MBRHOME_RIBBON_MEMID': aemContent.getContentValue(data['MBR_MBRHOME_RIBBON_MEMID']),
                                'MBR_MBRHOME_RIBBON_GROUPNUM': aemContent.getContentValue(data['MBR_MBRHOME_RIBBON_GROUPNUM']),
                                'MBR_MBRHOME_RIBBON_OTHERMEMINFO': aemContent.getContentValue(data['MBR_MBRHOME_RIBBON_OTHERMEMINFO']),
                                'MBR_MBRHOME_RIBBON_OTHERMEMINFO_NDBCBS': aemContent.getContentValue(data['MBR_MBRHOME_RIBBON_OTHERMEMINFO_NDBCBS']),
                                'MBR_MBRHOME_RIBBON_OTHERMEMINFO_HREF': aemContent.getContentValue(data['MBR_MBRHOME_RIBBON_OTHERMEMINFO_HREF']),
                                'MBR_MBRHOME_RIBBON_IDCARD': aemContent.getContentValue(data['MBR_MBRHOME_RIBBON_IDCARD']),
                                'MBR_MBRHOME_RIBBON_IDCARD_HREF': aemContent.getContentValue(data['MBR_MBRHOME_RIBBON_IDCARD_HREF']),
                                'MBR_MBRHOME_RIBBON_CVGSUM': aemContent.getContentValue(data['MBR_MBRHOME_RIBBON_CVGSUM']),
                                'MBR_MBRHOME_RIBBON_CVGSUM_HREF': aemContent.getContentValue(data['MBR_MBRHOME_RIBBON_CVGSUM_HREF']),
                                'MBR_MBRHOME_MSGCNTR_HREF': aemContent.getContentValue(data['MBR_MBRHOME_MSGCNTR_HREF']),
                                'MBR_MBRHOME_REVIEW_MSGS': aemContent.getContentValue(data['MBR_MBRHOME_REVIEW_MSGS']),
                                'MBR_MBRHOME_NEW_MSGS': aemContent.getContentValue(data['MBR_MBRHOME_NEW_MSGS']),
                                'MBR_MBRHOME_CHOOSE_YOUR_PCP_MODAL': aemContent.getContentValue(data['MBR_MBRHOME_CHOOSE_YOUR_PCP_MODAL']),
                                'MBR_MBRHOME_RIBBON_BB': aemContent.getContentValue(data['MBR_MBRHOME_RIBBON_BB']),
                                'MER_BENEFITBOOKLET_ERROR': aemContent.getContentValue(data['MER_BENEFITBOOKLET_ERROR']),
                                'MBR_BENEFITBOOKLET_LANDINGPAGE_ERROR': aemContent.getContentValue(data['MBR_BENEFITBOOKLET_LANDINGPAGE_ERROR']),
                                'MBR_BENEFITBOOKLET_QUALTRICS_LINK': aemContent.getContentValue(data['MBR_BENEFITBOOKLET_QUALTRICS_LINK']),
                                'MBR_BENEFITBOOKLET_LANDINGPAGE_ERROR_CODE': aemContent.getContentValue(data['MBR_BENEFITBOOKLET_LANDINGPAGE_ERROR_CODE']),
                                'FORMS_LIBRARY_NOT_ENTITLED_MODAL_CONTENT': aemContent.getContentValue(data['FORMS_LIBRARY_NOT_ENTITLED_MODAL_CONTENT']),
                                'FORMS_LIBRARY_NOT_ENTITLED_MODAL_TITLE': aemContent.getContentValue(data['FORMS_LIBRARY_NOT_ENTITLED_MODAL_TITLE']),
                                'MBR_MBRHOME_COVERAGE_SUMMARYTTIP': aemContent.getContentValue(data['MBR_MBRHOME_COVERAGE_SUMMARYTTIP']),
                                'MBR_MBRHOME_COVERAGE_SUMMARYTTIP_HREF': aemContent.getContentValue(data['MBR_MBRHOME_COVERAGE_SUMMARYTTIP_HREF']),
                                'MBR_MBRHOME_COVERAGE_DEDUCTIBLE': aemContent.getContentValue(data['MBR_MBRHOME_COVERAGE_DEDUCTIBLE']),
                                'MBR_MBRHOME_COVERAGE_COPAYS': aemContent.getContentValue(data['MBR_MBRHOME_COVERAGE_COPAYS']),
                                'MBR_MBRHOME_COVERAGE_COINSURANCE': aemContent.getContentValue(data['MBR_MBRHOME_COVERAGE_COINSURANCE']),
                                'MBR_MBRHOME_COVERAGE_OOPMAX': aemContent.getContentValue(data['MBR_MBRHOME_COVERAGE_OOPMAX']),
                                'MBR_MBRHOME_COVERAGE_FAMDEDUCTIBLE': aemContent.getContentValue(data['MBR_MBRHOME_COVERAGE_FAMDEDUCTIBLE']),
                                'MBR_MBRHOME_COVERAGE_HOMEHOST_TIERHEADER': aemContent.getContentValue(data['MBR_MBRHOME_COVERAGE_HOMEHOST_TIERHEADER']),
                                'MBR_MBRHOME_COVERAGE_HOMEHOST_REGION_TIERHEADER': aemContent.getContentValue(data['MBR_MBRHOME_COVERAGE_HOMEHOST_REGION_TIERHEADER']),
                                'MBR_MBRHOME_COVERAGE_HOMEHOST__REGION_TIERHEADER': aemContent.getContentValue(data['MBR_MBRHOME_COVERAGE_HOMEHOST__REGION_TIERHEADER']),
                                'MER_COVERAGE_SUMMARY_CSGRID_HOMEHOST_REGION_VALUE_HDR': aemContent.getContentValue(data['MER_COVERAGE_SUMMARY_CSGRID_HOMEHOST_REGION_VALUE_HDR']),
                                'MBR_MBRHOME_COVERAGE_TIERHEADER': aemContent.getContentValue(data['MBR_MBRHOME_COVERAGE_TIERHEADER']),
                                'MBR_MBRHOME_COVERAGE_TIERHEADERFOUR': aemContent.getContentValue(data['MBR_MBRHOME_COVERAGE_TIERHEADERFOUR']),
                                'MBR_MBRHOME_COVERAGE_TIERHEADERNONE': aemContent.getContentValue(data['MBR_MBRHOME_COVERAGE_TIERHEADERNONE']),
                                'MBR_MBRHOME_COVERAGE_TIERHEADERTHREE': aemContent.getContentValue(data['MBR_MBRHOME_COVERAGE_TIERHEADERTHREE']),
                                'MBR_MBRHOME_FINDOCTORPROMO_TITILE': aemContent.getContentValue(data['MBR_MBRHOME_FINDOCTORPROMO_TITILE']),
                                'MBR_MBRHOME_FINDOCTORPROMO_SUBTITILE': aemContent.getContentValue(data['MBR_MBRHOME_FINDOCTORPROMO_SUBTITILE']),
                                'MBR_MBRHOME_FINDOCTORPROMO_TEXT': aemContent.getContentValue(data['MBR_MBRHOME_FINDOCTORPROMO_TEXT']),
                                'MBR_MBRHOME_FINDOCTORPROMO_SEARCHLINK': aemContent.getContentValue(data['MBR_MBRHOME_FINDOCTORPROMO_SEARCHLINK']),
                                'MBR_LANDING_GUIDEWELL_MEDICARE_HEADING': aemContent.getContentValue(data['MBR_LANDING_GUIDEWELL_MEDICARE_HEADING']),
                                'MBR_LANDING_GUIDEWELL_MEDICARE_DESC': aemContent.getContentValue(data['MBR_LANDING_GUIDEWELL_MEDICARE_DESC']),
                                'MBR_LANDING_GUIDEWELL_MEDICARE_SMALLDESC': aemContent.getContentValue(data['MBR_LANDING_GUIDEWELL_MEDICARE_SMALLDESC']),
                                'MBR_LANDING_GUIDEWELL_MEDICARE_BUTTON': aemContent.getContentValue(data['MBR_LANDING_GUIDEWELL_MEDICARE_BUTTON']),
                                'MBR_LANDING_GUIDEWELL_HOME_HEADING': aemContent.getContentValue(data['MBR_LANDING_GUIDEWELL_HOME_HEADING']),
                                'MBR_LANDING_GUIDEWELL_HOME_DESC': aemContent.getContentValue(data['MBR_LANDING_GUIDEWELL_HOME_DESC']),
                                'MBR_LANDING_GUIDEWELL_HOME_BUTTON': aemContent.getContentValue(data['MBR_LANDING_GUIDEWELL_HOME_BUTTON']),
                                'SHOW_GUIDEWELL_UI_INDICATOR': aemContent.getContentValue(data['SHOW_GUIDEWELL_UI_INDICATOR']),
                                'MBR_BENEFIT_BOOKLET_SHOWBANNER_LADINGCOVERAGE_PAGE': aemContent.getContentValue(data['MBR_BENEFIT_BOOKLET_SHOWBANNER_LADINGCOVERAGE_PAGE'])
                            };
                        });
                    },

                    preRender: function() {
                        this.model = $scope;

                        var serviceCalls = [];
                        // serviceCalls.push(services.MemberInfo.getData());
                        serviceCalls.push(services.rbsmbl.memberInfo().fetch());
                        // serviceCalls.push(services.ServerDate.getDate());
                        serviceCalls.push(new Date());
                        // serviceCalls.push(services.Eligibility.getData());
                        serviceCalls.push(services.rbsmbl.eligibility().getData());
                        // serviceCalls.push(services.Information.getData());
                        serviceCalls.push(services.rbsmbl.vbbMemberInfo().getData());

                        serviceCalls.push(this.getTeamsiteContent());

                        $q.all(serviceCalls).then(lang.hitch(this, function (responses) {
                                    var theMemberInfo = responses[0].data.payload;
                                    var serverDate = new Date(responses[1]) || new Date();
                                    var dppData = responses[2].data.payload.dppIndicator;
                                    var infoData = responses[3].data.payload;
                                    this.model.tsContent = responses[4];
                                    // this.model.clientGroupProductQualifiedTSContent = this.self.page.model.clientGroupProductQualifiedTSContent;
                                    this.model.clientGroupProductQualifiedTSContent = {};
                                    var ts = this.model.tsContent;

                                    // this.model.memberQualifiers = this.self.page.model.memberQualifiers;
                                    this.model.memberQualifiers = $q.defer().promise;

                                    this.model.memberQualifiers.then(lang.hitch(this, function(response) {
                                        nd_wellnessProgramsIndicator = response.data.payload.qualifierInfo.wellnessProgramsIndicator;
                                        nd_wellnessProgramsOptInOutIndicator = response.data.payload.qualifierInfo.wellnessProgramsOptInOutIndicator;
                                    }));

                                    this.model.wellnessProfileScore = null;
                                    var ums = new umsParse(theMemberInfo, serverDate);
                                    var memberInfoFeed = ums.ASMemberInfoFeed();
                                    if (theMemberInfo && theMemberInfo.userName) {
                                        this.model.username = theMemberInfo.userName
                                    }

                                    if (theMemberInfo && theMemberInfo.brand) {
                                        this.model.brand = theMemberInfo.brand
                                    }
                                    this.model.memberInfoFeed = memberInfoFeed;
                                    this.model.currentMember = ums.currentMember();
                                    this.model.serverDate = serverDate;
                                    var portalSelectedPlan = ums.getPortalSelectedPlan();
                                    portalSelectedPlan = portalSelectedPlan && portalSelectedPlan[0];
                                    this.model.ums = ums;
                                    this.model.portalSelectedPlan = portalSelectedPlan;

                                    this.coreShowProgramGroup();  // this ran too late in init()
                                    this.coverageIsCancelled();
                                    this.isWellnessProfileOptout(theMemberInfo);
                                    // we gotta make the Programs array so that it is available to the setPreEffs method
                                    // then after the Get Wellness Score service returns we set the score and the hide/show
                                    portalSelectedNonMedicalPlan =this.getportalSelectedNonMedicalPlan();
                                    this.getVBBs();
                                    this.makeArrPrograms(dppData, infoData);
                                    this.setPreEffsValues();

                                    if (this.model.currentMember) {
                                        this.wellnessProfileItem();
                                        // this.getVBBs();
                                        // get eBill info so we know what popup to pop ----------------------------------
                                        var eBillInfo;

                                        if(preEffMemberType == 'preEffectuatedAndCancelled') {
                                            popupPreEffectuatedModal();
                                        }
                                        else if (preEffMemberType != 'none' && preEffMemberType != 'preEffective') {

                                            eBillInfo = services.eBill.getEBillInfo(portalSelectedPlan.groupNumber);
                                            eBillInfo.then(lang.hitch(this, function (theInfo) {
                                                if (theInfo && theInfo.data && theInfo.data.payload) {
                                                    var e = theInfo.data.payload
                                                    if (e.ebillaccountExists) {
                                                        this.model.eBillAccountExists = true;
                                                        if ((this.model.currentMember.relationship == 'Subscriber') && (is18)) {
                                                            preEffMemberType = 'adultReadyToPayButHasnt';
                                                        }
                                                        if (e.accounttnumber) {
                                                            this.model.eBillInfo = e;
                                                            // TODO use something like hmLocalStorage.set('eBillInfo', e);
                                                            localStorage.setItem('eBillInfo', JSON.stringify(e));
                                                        } else {
                                                            this.model.eBillInfo.phoneNum = '1-555-555-5555',
                                                                this.model.eBillInfo.accounttnumber = '11111111111',
                                                                this.model.eBillInfo.amountDue = '$' + '250.00',
                                                                this.model.eBillInfo.paymtduedate = '8/8/15'
                                                        }
                                                    } else {
                                                        this.model.eBillAccountExists = false
                                                    }
                                                }
                                                else {
                                                    this.model.eBillAccountExists = false;
                                                }
                                                // this.model.$apply();
                                                // this.setPreEffsValues();
                                                popupPreEffectuatedModal();
                                            }), lang.hitch(this, function (error) {
                                                this.model.eBillAccountExists = false;
                                                // this.model.$apply();
                                            }));
                                        }

                                        //wait for the wellness profile score to comeback and update the model, before populating model
                                        var self = this;
                                        this.callWellnessScoreService().then(function () {
                                            self.populateModel(self.model);
                                            // self.setPreEffsValues();
                                            // self.doStuffForDevelopmentOnly();
                                            // deferred.resolve();
                                        });
                                    }

                                }
                            )
                        );
                    }
                };

                function dojoConvert() { 
                    return toMerge;
                };
                var d = new dojoConvert();
                d.preRender();














            }]
        }
    })
}